import { useState, useEffect, useCallback } from "react";
import { useAuth, API } from "@/App";
import axios from "axios";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Progress } from "@/components/ui/progress";
import { toast } from "sonner";
import AlertScorteBasse from "@/components/AlertScorteBasse";
import { 
  Calendar, 
  Euro, 
  Users, 
  AlertTriangle,
  Plus,
  Clock,
  TrendingUp,
  Package,
  Cake,
  Target,
  Download,
  Send,
  FileSpreadsheet,
  Lock,
  Unlock,
  Eye,
  EyeOff,
  Gift,
  ChevronRight,
  Phone,
  MessageCircle,
  CheckCircle2,
  X,
  ArrowRight,
  Receipt,
  User,
  Bell,
  Scissors,
  Wallet,
  CreditCard
} from "lucide-react";
import { useNavigate } from "react-router-dom";
import { format, parseISO, isToday, addDays, startOfWeek, endOfWeek, isBefore, isAfter, differenceInDays } from "date-fns";
import { it } from "date-fns/locale";
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid, Legend } from "recharts";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

export default function Dashboard() {
  const { token } = useAuth();
  const navigate = useNavigate();
  const [stats, setStats] = useState(null);
  const [clientiRichiamare, setClientiRichiamare] = useState({ totale: 0, clienti: [] });
  const [clientiMesePerGenere, setClientiMesePerGenere] = useState({ uomo: 0, donna: 0, altro: 0, totale: 0, lista_uomo: [], lista_donna: [], lista_altro: [] });
  const [serviziScaduti, setServiziScaduti] = useState({ totale_alert: 0, alerts: [] });
  const [showServiziScadutiDialog, setShowServiziScadutiDialog] = useState(false);
  // Scadenze pagamenti (banner rosso entro 7 giorni)
  const [scadenze, setScadenze] = useState(null);
  const [showScadenzeDialog, setShowScadenzeDialog] = useState(false);
  const [clientiMeseDialog, setClientiMeseDialog] = useState({ open: false, genere: null });
  const [loading, setLoading] = useState(true);
  
  // Compleanni
  const [compleanni, setCompleanni] = useState([]);
  const [compleanniFilter, setCompleanniFilter] = useState("settimana"); // oggi, settimana, mese
  const [showCompleanniDialog, setShowCompleanniDialog] = useState(false);
  
  // Obiettivo mensile
  const [obiettivoMensile, setObiettivoMensile] = useState(0);
  const [incassoMensile, setIncassoMensile] = useState(0);
  const [previsionaleData, setPrevisionaleData] = useState({
    previsionale: 0,
    incasso_reale: 0,
    incasso_card_utilizzata: 0,
    totale_giornata_previsto: 0,
    appuntamenti_da_incassare: 0,
    appuntamenti_incassati: 0,
    totale_appuntamenti: 0,
    obiettivo_mensile: 0,
    obiettivo_giornaliero: 0,
    giorni_lavorativi_mese: 0,
    chiusure_straordinarie_mese: 0,
    mese_corrente: '',
    percentuale_obiettivo: 0
  });
  const [reportMensile, setReportMensile] = useState(null);
  const [showReportDialog, setShowReportDialog] = useState(false);
  const [showObiettivoDialog, setShowObiettivoDialog] = useState(false);
  const [obiettivoPin, setObiettivoPin] = useState("");
  const [pinInput, setPinInput] = useState("");
  // Persist unlock in session — così non deve rifare il PIN ogni volta
  const [obiettivoUnlocked, setObiettivoUnlocked] = useState(() => {
    try { return localStorage.getItem('obiettivo_unlocked') === 'true'; } catch { return false; }
  });
  const [nuovoObiettivo, setNuovoObiettivo] = useState("");
  const [nuovoPin, setNuovoPin] = useState("");
  // Selettore mese pianificazione (default: mese corrente)
  const [meseSelezionato, setMeseSelezionato] = useState(() => format(new Date(), 'yyyy-MM'));
  const [obiettiviMensili, setObiettiviMensili] = useState({}); // { "YYYY-MM": {obiettivo, soglie} }
  // Dialog dedicato per pianificazione mese
  const [pianifDialogOpen, setPianifDialogOpen] = useState(false);
  const [pianifForm, setPianifForm] = useState({ obiettivo: 0, soglie: {} });
  const [pianifMese, setPianifMese] = useState(format(new Date(), 'yyyy-MM'));
  const [savingPianif, setSavingPianif] = useState(false);
  
  // Scorte
  const [showScorteDialog, setShowScorteDialog] = useState(false);
  const [scorteReport, setScorteReport] = useState({ rivendita: [], tecnico: [] });
  // Soglie di spesa mese (per alert Desk)
  const [spesevsSoglie, setSpeseVsSoglie] = useState(null);
  const [soglieMode, setSoglieMode] = useState("reale"); // "reale" o "obiettivo"
  const [soglieDialogOpen, setSoglieDialogOpen] = useState(false);
  const [soglieForm, setSoglieForm] = useState({});
  const [savingSoglie, setSavingSoglie] = useState(false);
  const refetchSoglie = useCallback((mode, meseFiltro) => {
    const m = meseFiltro || meseSelezionato;
    axios.get(`${API}/analytics/spese-vs-soglie?vs=${mode || soglieMode}&mese=${m}`, { headers: { Authorization: `Bearer ${token}` } })
      .then(r => setSpeseVsSoglie(r.data))
      .catch(() => {});
  }, [token, soglieMode, meseSelezionato]);
  const [generatingReport, setGeneratingReport] = useState(false);

  // Riepilogo Card Attive (PIN protetto)
  const [showCardsDialog, setShowCardsDialog] = useState(false);
  const [cardsPinAttivo, setCardsPinAttivo] = useState(false);
  const [cardsPinInput, setCardsPinInput] = useState("");
  const [cardsPinError, setCardsPinError] = useState("");
  const [cardsRiepilogo, setCardsRiepilogo] = useState(null); // { riepilogo, cards }
  const [cardsLoading, setCardsLoading] = useState(false);

  // Spesa Rapida
  const [spesaRapidaOpen, setSpesaRapidaOpen] = useState(false);
  const [macrocategorie, setMacrocategorie] = useState([]);
  const [categorie, setCategorie] = useState([]);
  const [spesaForm, setSpesaForm] = useState({
    macrocategoria_id: "",
    categoria_id: "",
    descrizione: "",
    importo: "",
    data_spesa: format(new Date(), "yyyy-MM-dd")
  });

  // Scarico Magazzino
  const [scaricoMagazzinoOpen, setScaricoMagazzinoOpen] = useState(false);
  const [scaricoRicerca, setScaricoRicerca] = useState("");
  const [prodottiMagazzino, setProdottiMagazzino] = useState([]);
  const [scaricoForm, setScaricoForm] = useState({
    prodotto_id: "",
    quantita: "1",
    motivo: "utilizzo",
    note: ""
  });

  const fetchStats = useCallback(async () => {
    try {
      const response = await axios.get(`${API}/dashboard/stats`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setStats(response.data);
      setIncassoMensile(response.data.incasso_mese || 0);
    } catch (error) {
      console.error('Errore caricamento stats:', error);
    } finally {
      setLoading(false);
    }
  }, [token]);

  const fetchClientiRichiamare = useCallback(async () => {
    try {
      const response = await axios.get(`${API}/marketing/clienti-da-richiamare?giorni_assenza=60&limite=5`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setClientiRichiamare({
        totale: response.data?.totale || 0,
        clienti: response.data?.clienti || []
      });
    } catch (error) {
      console.error('Errore clienti da richiamare:', error);
    }
  }, [token]);

  const fetchClientiMesePerGenere = useCallback(async () => {
    try {
      const response = await axios.get(`${API}/dashboard/clienti-mese-per-genere`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setClientiMesePerGenere(response.data || { uomo: 0, donna: 0, altro: 0, totale: 0 });
    } catch (error) {
      console.error('Errore clienti per genere:', error);
    }
  }, [token]);

  const fetchServiziScaduti = useCallback(async () => {
    try {
      const response = await axios.get(`${API}/dashboard/servizi-scaduti-prossimi-appuntamenti?giorni_avanti=7`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setServiziScaduti(response.data || { totale_alert: 0, alerts: [] });
    } catch (error) {
      console.error('Errore servizi scaduti:', error);
    }
  }, [token]);

  const fetchScadenze = useCallback(async () => {
    try {
      const response = await axios.get(`${API}/bilancio/scadenze-imminenti?giorni=7`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setScadenze(response.data || null);
    } catch (error) {
      console.error('Errore fetch scadenze pagamenti:', error);
    }
  }, [token]);


  const fetchCompleanni = useCallback(async () => {
    try {
      const response = await axios.get(`${API}/clienti`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      
      const clienti = response.data;
      const oggi = new Date();
      const annoCorrente = oggi.getFullYear();
      
      // Filtra clienti con data di nascita e calcola prossimo compleanno
      const clientiConCompleanno = clienti
        .filter(c => c.data_nascita)
        .map(c => {
          const dataNascita = parseISO(c.data_nascita);
          let prossimoCompleanno = new Date(annoCorrente, dataNascita.getMonth(), dataNascita.getDate());
          
          // Se il compleanno è già passato quest'anno, usa l'anno prossimo
          if (isBefore(prossimoCompleanno, oggi) && !isToday(prossimoCompleanno)) {
            prossimoCompleanno = new Date(annoCorrente + 1, dataNascita.getMonth(), dataNascita.getDate());
          }
          
          return {
            ...c,
            prossimoCompleanno,
            giorniMancanti: differenceInDays(prossimoCompleanno, oggi),
            eta: annoCorrente - dataNascita.getFullYear()
          };
        })
        .sort((a, b) => a.giorniMancanti - b.giorniMancanti);
      
      setCompleanni(clientiConCompleanno);
    } catch (error) {
      console.error('Errore caricamento compleanni:', error);
    }
  }, [token]);

  const fetchObiettivo = useCallback(async () => {
    try {
      const response = await axios.get(`${API}/configurazione`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setObiettivoMensile(response.data.obiettivo_mensile || 0);
      setObiettivoPin(response.data.obiettivo_pin || "");
    } catch (error) {
      console.error('Errore caricamento obiettivo:', error);
    }
  }, [token]);

  const fetchPrevisionale = useCallback(async () => {
    try {
      const response = await axios.get(`${API}/dashboard/previsionale-giorno`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setPrevisionaleData(response.data);
    } catch (error) {
      console.error('Errore caricamento previsionale:', error);
    }
  }, [token]);

  // Fetch macrocategorie per spesa rapida
  const fetchMacrocategorie = useCallback(async () => {
    try {
      const [macroRes, catRes] = await Promise.all([
        axios.get(`${API}/spese/macrocategorie`, { headers: { Authorization: `Bearer ${token}` }}),
        axios.get(`${API}/spese/categorie`, { headers: { Authorization: `Bearer ${token}` }})
      ]);
      setMacrocategorie(macroRes.data);
      setCategorie(catRes.data);
      
      // Init categorie se vuote
      if (macroRes.data.length === 0) {
        await axios.post(`${API}/spese/init-categorie`, {}, { headers: { Authorization: `Bearer ${token}` }});
        const [m, c] = await Promise.all([
          axios.get(`${API}/spese/macrocategorie`, { headers: { Authorization: `Bearer ${token}` }}),
          axios.get(`${API}/spese/categorie`, { headers: { Authorization: `Bearer ${token}` }})
        ]);
        setMacrocategorie(m.data);
        setCategorie(c.data);
      }
    } catch (error) {
      console.error('Errore init categorie:', error);
    }
  }, [token]);

  // Fetch prodotti per scarico magazzino
  const fetchProdottiMagazzino = useCallback(async () => {
    try {
      const response = await axios.get(`${API}/prodotti`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setProdottiMagazzino(response.data);
    } catch (error) {
      console.error('Errore caricamento prodotti:', error);
    }
  }, [token]);

  // Fetch obiettivi pianificati per mese
  const fetchObiettiviMensili = useCallback(async () => {
    try {
      const r = await axios.get(`${API}/config/obiettivi-mensili`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setObiettiviMensili(r.data.obiettivi_mensili || {});
    } catch { /* ignore */ }
  }, [token]);

  // Fetch riepilogo annuale (piano vs reale per 12 mesi)
  const [pianAnnuale, setPianAnnuale] = useState(null);
  const [annoPianificazione, setAnnoPianificazione] = useState(new Date().getFullYear());
  const fetchPianificazioneAnnuale = useCallback(async (anno) => {
    try {
      const r = await axios.get(`${API}/analytics/pianificazione-annuale?anno=${anno || annoPianificazione}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setPianAnnuale(r.data);
    } catch { /* ignore */ }
  }, [token, annoPianificazione]);

  // Effect per caricare i dati iniziali
  useEffect(() => {
    fetchStats();
    fetchCompleanni();
    fetchObiettivo();
    fetchPrevisionale();
    fetchClientiRichiamare();
    fetchClientiMesePerGenere();
    fetchServiziScaduti();
    fetchScadenze();
    // Fetch soglie spesa per banner alert
    refetchSoglie();
    fetchObiettiviMensili();
    fetchPianificazioneAnnuale();
  }, [fetchStats, fetchCompleanni, fetchObiettivo, fetchPrevisionale, fetchClientiRichiamare, fetchClientiMesePerGenere, fetchServiziScaduti, fetchScadenze, refetchSoglie, fetchObiettiviMensili, fetchPianificazioneAnnuale]);

  const fetchReportMensile = async () => {
    try {
      const response = await axios.get(`${API}/dashboard/report-mensile`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setReportMensile(response.data);
      setShowReportDialog(true);
    } catch (error) {
      toast.error("Errore nel caricamento del report");
    }
  };

  const saveObiettivo = async () => {
    try {
      await axios.put(`${API}/configurazione`, {
        obiettivo_mensile: parseFloat(nuovoObiettivo) || 0,
        obiettivo_pin: nuovoPin || obiettivoPin
      }, {
        headers: { Authorization: `Bearer ${token}` }
      });
      
      setObiettivoMensile(parseFloat(nuovoObiettivo) || 0);
      if (nuovoPin) setObiettivoPin(nuovoPin);
      setShowObiettivoDialog(false);
      setNuovoObiettivo("");
      setNuovoPin("");
      toast.success("Obiettivo salvato!");
    } catch (error) {
      toast.error("Errore nel salvataggio");
    }
  };

  const verificaPin = () => {
    if (pinInput === obiettivoPin) {
      setObiettivoUnlocked(true);
      try { localStorage.setItem('obiettivo_unlocked', 'true'); } catch { /* noop */ }
      setPinInput("");
    } else {
      toast.error("PIN errato!");
    }
  };
  const lockObiettivo = () => {
    setObiettivoUnlocked(false);
    try { localStorage.removeItem('obiettivo_unlocked'); } catch { /* noop */ }
  };


  // Filtra compleanni in base al filtro selezionato
  const getCompeleanniFiltrati = () => {
    const oggi = new Date();
    
    switch (compleanniFilter) {
      case "oggi":
        return compleanni.filter(c => c.giorniMancanti === 0);
      case "settimana":
        return compleanni.filter(c => c.giorniMancanti >= 0 && c.giorniMancanti <= 7);
      case "mese":
        return compleanni.filter(c => c.giorniMancanti >= 0 && c.giorniMancanti <= 30);
      default:
        return compleanni.filter(c => c.giorniMancanti >= 0 && c.giorniMancanti <= 7);
    }
  };

  // Genera report scorte settimanale
  // === Riepilogo Card Attive ===
  const openCardsRiepilogo = async () => {
    setCardsPinError("");
    setCardsRiepilogo(null);
    setCardsPinInput("");
    setShowCardsDialog(true);
    try {
      // Controlla se è richiesto il PIN
      const res = await axios.get(`${API}/cards/riepilogo/pin-stato`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      const pinRichiesto = res.data?.pin_attivo;
      setCardsPinAttivo(pinRichiesto);
      // Se non richiesto, carica subito i dati
      if (!pinRichiesto) {
        await loadCardsRiepilogo("");
      }
    } catch {
      // fallback: tenta sempre con PIN
      setCardsPinAttivo(true);
    }
  };

  const loadCardsRiepilogo = async (pin) => {
    setCardsLoading(true);
    setCardsPinError("");
    try {
      const res = await axios.post(
        `${API}/cards/riepilogo`,
        { pin: pin || "" },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setCardsRiepilogo(res.data);
    } catch (error) {
      if (error.response?.status === 403) {
        setCardsPinError("PIN errato. Riprova.");
      } else {
        setCardsPinError("Errore nel caricamento del riepilogo");
      }
    } finally {
      setCardsLoading(false);
    }
  };


  const generateScorteReport = async () => {
    setGeneratingReport(true);
    try {
      const response = await axios.get(`${API}/prodotti`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      
      const prodotti = response.data;
      
      // Dividi per categoria
      const rivendita = prodotti.filter(p => 
        (p.categoria || "").toLowerCase().includes("rivendita") ||
        (p.tipo || "").toLowerCase().includes("rivendita")
      );
      
      const tecnico = prodotti.filter(p => 
        (p.categoria || "").toLowerCase().includes("tecnico") ||
        (p.tipo || "").toLowerCase().includes("tecnico") ||
        (p.categoria || "").toLowerCase().includes("professionale")
      );
      
      // Se non ci sono categorie specifiche, dividi in base al prezzo o alla quantità
      const altriProdotti = prodotti.filter(p => 
        !rivendita.includes(p) && !tecnico.includes(p)
      );
      
      // Aggiungi gli altri alla rivendita per default
      const rivenditaFinal = [...rivendita, ...altriProdotti.filter(p => (p.prezzo_vendita || 0) > 0)];
      const tecnicoFinal = [...tecnico, ...altriProdotti.filter(p => (p.prezzo_vendita || 0) === 0)];
      
      setScorteReport({
        rivendita: rivenditaFinal,
        tecnico: tecnicoFinal.length > 0 ? tecnicoFinal : prodotti // Fallback a tutti se nessun tecnico
      });
      
      setShowScorteDialog(true);
    } catch (error) {
      toast.error("Errore nel caricamento prodotti");
    } finally {
      setGeneratingReport(false);
    }
  };

  // Genera CSV
  const generateCSV = (tipo) => {
    const prodotti = tipo === "rivendita" ? scorteReport.rivendita : scorteReport.tecnico;
    const oggi = format(new Date(), "yyyy-MM-dd");
    const settimana = `${format(startOfWeek(new Date(), { locale: it }), "dd-MM")} - ${format(endOfWeek(new Date(), { locale: it }), "dd-MM-yyyy")}`;
    
    let csv = `REPORT SCORTE ${tipo.toUpperCase()} - SETTIMANA ${settimana}\n\n`;
    csv += "Nome Prodotto;Codice;Quantità;Scorta Minima;Prezzo Acquisto;Prezzo Vendita;Da Ordinare\n";
    
    prodotti.forEach(p => {
      const daOrdinare = (p.quantita || 0) < (p.scorta_minima || 0) ? "SI" : "NO";
      csv += `${p.nome || ""};${p.codice || ""};${p.quantita || 0};${p.scorta_minima || 0};€${(p.prezzo_acquisto || 0).toFixed(2)};€${(p.prezzo_vendita || 0).toFixed(2)};${daOrdinare}\n`;
    });
    
    // Riepilogo
    csv += `\n--- RIEPILOGO ---\n`;
    csv += `Totale Prodotti: ${prodotti.length}\n`;
    csv += `Prodotti da ordinare: ${prodotti.filter(p => (p.quantita || 0) < (p.scorta_minima || 0)).length}\n`;
    
    return csv;
  };

  // Download CSV
  const downloadCSV = (tipo) => {
    const csv = generateCSV(tipo);
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    const url = URL.createObjectURL(blob);
    link.setAttribute("href", url);
    link.setAttribute("download", `scorte_${tipo}_${format(new Date(), "yyyy-MM-dd")}.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    toast.success(`File CSV ${tipo} scaricato!`);
  };

  // Invia CSV via WhatsApp (apre link)
  const sendCSVWhatsApp = (tipo) => {
    const prodotti = tipo === "rivendita" ? scorteReport.rivendita : scorteReport.tecnico;
    const prodottiDaOrdinare = prodotti.filter(p => (p.quantita || 0) < (p.scorta_minima || 0));
    
    let message = `📦 *REPORT SCORTE ${tipo.toUpperCase()}*\n`;
    message += `📅 Settimana: ${format(startOfWeek(new Date(), { locale: it }), "dd/MM")} - ${format(endOfWeek(new Date(), { locale: it }), "dd/MM/yyyy")}\n\n`;
    
    if (prodottiDaOrdinare.length > 0) {
      message += `⚠️ *PRODOTTI DA ORDINARE (${prodottiDaOrdinare.length}):*\n`;
      prodottiDaOrdinare.forEach(p => {
        message += `• ${p.nome}: ${p.quantita || 0} pz (min: ${p.scorta_minima || 0})\n`;
      });
    } else {
      message += `✅ Nessun prodotto da ordinare!\n`;
    }
    
    message += `\n📊 Totale prodotti: ${prodotti.length}`;
    
    const encodedMessage = encodeURIComponent(message);
    window.open(`https://wa.me/?text=${encodedMessage}`, "_blank");
  };

  // Salva spesa rapida
  const handleSalvaSpesaRapida = async () => {
    if (!spesaForm.macrocategoria_id || !spesaForm.importo) {
      toast.error("Compila macrocategoria e importo");
      return;
    }
    try {
      await axios.post(`${API}/spese`, {
        ...spesaForm,
        importo: parseFloat(spesaForm.importo)
      }, { headers: { Authorization: `Bearer ${token}` }});
      toast.success("Spesa registrata!");
      setSpesaRapidaOpen(false);
      setSpesaForm({
        macrocategoria_id: "",
        categoria_id: "",
        descrizione: "",
        importo: "",
        data_spesa: format(new Date(), "yyyy-MM-dd")
      });
    } catch (error) {
      toast.error("Errore nel salvataggio");
    }
  };

  // Scarica prodotto dal magazzino
  const handleScaricoMagazzino = async () => {
    if (!scaricoForm.prodotto_id || !scaricoForm.quantita) {
      toast.error("Seleziona prodotto e quantità");
      return;
    }
    try {
      await axios.post(`${API}/magazzino/scarica`, {
        prodotto_id: scaricoForm.prodotto_id,
        quantita: parseFloat(scaricoForm.quantita),
        motivo: scaricoForm.motivo,
        note: scaricoForm.note
      }, { headers: { Authorization: `Bearer ${token}` }});
      toast.success("Prodotto scaricato dal magazzino!");
      setScaricoMagazzinoOpen(false);
      setScaricoForm({ prodotto_id: "", quantita: "1", motivo: "utilizzo", note: "" });
    } catch (error) {
      toast.error("Errore nello scarico");
    }
  };

  // Apri dialog spesa e carica macrocategorie
  const openSpesaRapida = () => {
    fetchMacrocategorie();
    setSpesaRapidaOpen(true);
  };

  // Apri dialog scarico e carica prodotti
  const openScaricoMagazzino = () => {
    fetchProdottiMagazzino();
    setScaricoMagazzinoOpen(true);
  };

  // Calcola percentuale obiettivo
  const percentualeObiettivo = obiettivoMensile > 0 
    ? Math.min(100, (incassoMensile / obiettivoMensile) * 100) 
    : 0;

  if (loading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  const compleanniOggi = compleanni.filter(c => c.giorniMancanti === 0);
  const compleanniSettimana = compleanni.filter(c => c.giorniMancanti > 0 && c.giorniMancanti <= 7);

  return (
    <div className="space-y-8" data-testid="dashboard">
      {/* Alert Scorte Basse - Banner in alto */}
      <AlertScorteBasse 
        token={token}
        API={API}
        variant="banner"
        onNavigateToMagazzino={() => navigate('/magazzino')}
      />
      
      {/* Welcome Banner */}
      <div className="bg-gradient-to-r from-blue-600 via-indigo-600 to-purple-600 rounded-3xl p-8 text-white shadow-xl shadow-blue-500/20">
        <h1 className="text-3xl font-bold tracking-tight mb-2">Buongiorno!</h1>
        <p className="text-blue-100 text-lg">Ecco il riepilogo della giornata</p>
      </div>

      {/* Stats Grid - Bento Style - TUTTI CLICCABILI */}
      {/* Banner Clienti da Richiamare */}
      {clientiRichiamare.totale > 0 && (
        <button
          onClick={() => navigate('/analisi?tab=marketing')}
          className="w-full flex items-center justify-between gap-3 p-4 rounded-2xl bg-gradient-to-r from-amber-100 via-orange-50 to-amber-50 border-2 border-amber-200 hover:border-amber-400 hover:shadow-lg transition-all text-left"
          data-testid="dashboard-banner-richiamare"
        >
          <div className="flex items-center gap-3 min-w-0">
            <div className="w-12 h-12 rounded-2xl bg-amber-500 flex items-center justify-center shrink-0 shadow-md">
              <Phone className="w-6 h-6 text-white" />
            </div>
            <div className="min-w-0">
              <p className="text-base sm:text-lg font-bold text-amber-900">
                {clientiRichiamare.totale} client{clientiRichiamare.totale === 1 ? 'e' : 'i'} da richiamare
              </p>
              <p className="text-xs sm:text-sm text-amber-700 truncate">
                Non vengono in salone da almeno 60 giorni — click per vedere la lista
              </p>
            </div>
          </div>
          <ChevronRight className="w-5 h-5 text-amber-600 shrink-0" />
        </button>
      )}

      {/* Banner Servizi Scaduti per appuntamenti prossimi - SEMPRE VISIBILE */}
      <button
        onClick={() => setShowServiziScadutiDialog(true)}
        className={`w-full flex items-center justify-between gap-3 p-4 rounded-2xl border-2 hover:shadow-lg transition-all text-left ${
          serviziScaduti.totale_alert > 0
            ? 'bg-gradient-to-r from-rose-100 via-red-50 to-rose-50 border-rose-200 hover:border-rose-400'
            : 'bg-gradient-to-r from-emerald-50 via-green-50 to-emerald-50 border-emerald-200 hover:border-emerald-400'
        }`}
        data-testid="dashboard-banner-servizi-scaduti"
      >
        <div className="flex items-center gap-3 min-w-0">
          <div className={`w-12 h-12 rounded-2xl flex items-center justify-center shrink-0 shadow-md relative ${
            serviziScaduti.totale_alert > 0 ? 'bg-rose-500' : 'bg-emerald-500'
          }`}>
            <Bell className="w-6 h-6 text-white" />
            {serviziScaduti.totale_alert > 0 && (
              <span className="absolute -top-1 -right-1 bg-white text-rose-600 text-[10px] font-black rounded-full w-5 h-5 flex items-center justify-center shadow border border-rose-300">
                {serviziScaduti.totale_alert}
              </span>
            )}
          </div>
          <div className="min-w-0">
            {serviziScaduti.totale_alert > 0 ? (
              <>
                <p className="text-base sm:text-lg font-bold text-rose-900">
                  {serviziScaduti.totale_alert} servizi{serviziScaduti.totale_alert === 1 ? 'o' : ''} in ritardo nei prossimi 7 giorni
                </p>
                <p className="text-xs sm:text-sm text-rose-700 truncate">
                  {serviziScaduti.alerts.slice(0, 2).map(a =>
                    `${a.cliente_nome.toUpperCase()}: ${a.servizio} da ${a.giorni_assenza}gg (timer ${a.giorni_richiamo}gg)`
                  ).join(' • ')}
                  {serviziScaduti.alerts.length > 2 ? ` • +${serviziScaduti.alerts.length - 2} altri` : ''}
                </p>
              </>
            ) : (
              <>
                <p className="text-base sm:text-lg font-bold text-emerald-900">
                  Notifiche giorno di richiamo
                </p>
                <p className="text-xs sm:text-sm text-emerald-700 truncate">
                  Nessun servizio in ritardo nei prossimi 7 giorni — click per controllare la configurazione
                </p>
              </>
            )}
          </div>
        </div>
        <ChevronRight className={`w-5 h-5 shrink-0 ${serviziScaduti.totale_alert > 0 ? 'text-rose-600' : 'text-emerald-600'}`} />
      </button>

      {/* Banner Scadenze Pagamenti - visibile SOLO se ci sono scadenze/scadute */}
      {scadenze && scadenze.totale_scadenze > 0 && (
        <button
          onClick={() => setShowScadenzeDialog(true)}
          className={`w-full flex items-center justify-between gap-3 p-4 rounded-2xl border-2 hover:shadow-lg transition-all text-left ${
            scadenze.num_scadute > 0
              ? 'bg-gradient-to-r from-red-100 via-orange-50 to-red-50 border-red-300 hover:border-red-500 animate-pulse'
              : 'bg-gradient-to-r from-amber-50 via-yellow-50 to-amber-50 border-amber-300 hover:border-amber-500'
          }`}
          data-testid="dashboard-banner-scadenze"
        >
          <div className="flex items-center gap-3 min-w-0">
            <div className={`w-12 h-12 rounded-2xl flex items-center justify-center shrink-0 shadow-md relative ${
              scadenze.num_scadute > 0 ? 'bg-red-600' : 'bg-amber-500'
            }`}>
              <Wallet className="w-6 h-6 text-white" />
              <span className="absolute -top-1 -right-1 bg-white text-red-600 text-[10px] font-black rounded-full w-5 h-5 flex items-center justify-center shadow border border-red-300">
                {scadenze.totale_scadenze}
              </span>
            </div>
            <div className="min-w-0">
              <p className={`text-base sm:text-lg font-bold ${scadenze.num_scadute > 0 ? 'text-red-900' : 'text-amber-900'}`}>
                {scadenze.num_scadute > 0 && (
                  <span className="mr-1">⚠</span>
                )}
                {scadenze.num_scadute > 0
                  ? `${scadenze.num_scadute} pagament${scadenze.num_scadute === 1 ? 'o SCADUTO' : 'i SCADUTI'}`
                  : `${scadenze.num_in_scadenza} pagament${scadenze.num_in_scadenza === 1 ? 'o' : 'i'} in scadenza nei prossimi 7 giorni`}
                {scadenze.num_scadute > 0 && scadenze.num_in_scadenza > 0 && (
                  <span className="text-sm font-semibold ml-1">+ {scadenze.num_in_scadenza} in scadenza</span>
                )}
              </p>
              <p className={`text-xs sm:text-sm truncate ${scadenze.num_scadute > 0 ? 'text-red-700' : 'text-amber-700'}`}>
                Totale da pagare: <span className="font-bold">€{scadenze.totale_importo.toFixed(2)}</span>
                {' • '}
                {[...scadenze.scadute, ...scadenze.in_scadenza].slice(0, 2).map(s =>
                  `${s.descrizione} (${s.scaduta ? `scaduto ${-s.giorni_rimanenti}gg fa` : `tra ${s.giorni_rimanenti}gg`})`
                ).join(' • ')}
                {scadenze.totale_scadenze > 2 && ` • +${scadenze.totale_scadenze - 2} altri`}
              </p>
            </div>
          </div>
          <ChevronRight className={`w-5 h-5 shrink-0 ${scadenze.num_scadute > 0 ? 'text-red-600' : 'text-amber-600'}`} />
        </button>
      )}

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-6">
        {/* Appuntamenti Oggi - Click va all'Agenda */}
        <Card 
          className="bg-white rounded-3xl border-0 shadow-lg shadow-slate-100/80 hover:shadow-xl hover:-translate-y-1 transition-all duration-300 cursor-pointer" 
          data-testid="stat-appointments"
          onClick={() => navigate('/agenda')}
        >
          <CardContent className="p-6">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm font-medium text-slate-400 uppercase tracking-wide">Appuntamenti Oggi</p>
                <p className="text-4xl font-bold text-slate-800 mt-2 tracking-tight">
                  {stats?.appuntamenti_oggi || 0}
                </p>
                <p className="text-xs text-blue-600 mt-1 flex items-center gap-1">
                  Vai all'Agenda <ChevronRight className="w-3 h-3" />
                </p>
              </div>
              <div className="w-14 h-14 rounded-2xl bg-gradient-to-br from-blue-500 to-indigo-500 flex items-center justify-center shadow-lg shadow-blue-500/30">
                <Calendar className="w-7 h-7 text-white" />
              </div>
            </div>
          </CardContent>
        </Card>

        {/* Incasso Oggi - Click va alla Cassa */}
        <Card 
          className="bg-white rounded-3xl border-0 shadow-lg shadow-slate-100/80 hover:shadow-xl hover:-translate-y-1 transition-all duration-300 cursor-pointer" 
          data-testid="stat-revenue"
          onClick={() => navigate('/cassa')}
        >
          <CardContent className="p-6">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm font-medium text-slate-400 uppercase tracking-wide">Incasso Oggi</p>
                <p className="text-4xl font-bold text-emerald-600 mt-2 tracking-tight">
                  €{(stats?.incasso_oggi || 0).toFixed(0)}
                </p>
                <p className="text-xs text-emerald-600 mt-1 flex items-center gap-1">
                  Vai alla Cassa <ChevronRight className="w-3 h-3" />
                </p>
              </div>
              <div className="w-14 h-14 rounded-2xl bg-gradient-to-br from-emerald-500 to-teal-500 flex items-center justify-center shadow-lg shadow-emerald-500/30">
                <Euro className="w-7 h-7 text-white" />
              </div>
            </div>
          </CardContent>
        </Card>

        {/* Clienti UOMO del mese - Click va ai Clienti */}
        <Card 
          className="bg-white rounded-3xl border-0 shadow-lg shadow-slate-100/80 hover:shadow-xl hover:-translate-y-1 transition-all duration-300 cursor-pointer" 
          data-testid="stat-clienti-uomo-mese"
          onClick={() => setClientiMeseDialog({ open: true, genere: 'M' })}
        >
          <CardContent className="p-6">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm font-medium text-slate-400 uppercase tracking-wide">Clienti UOMO mese</p>
                <p className="text-4xl font-bold text-slate-800 mt-2 tracking-tight">
                  {clientiMesePerGenere.uomo || 0}
                </p>
                <p className="text-xs text-sky-600 mt-1 flex items-center gap-1">
                  Vedi lista <ChevronRight className="w-3 h-3" />
                </p>
              </div>
              <div className="w-14 h-14 rounded-2xl bg-gradient-to-br from-sky-500 to-blue-600 flex items-center justify-center shadow-lg shadow-sky-500/30">
                <User className="w-7 h-7 text-white" />
              </div>
            </div>
          </CardContent>
        </Card>

        {/* Clienti DONNA del mese - Click va ai Clienti */}
        <Card 
          className="bg-white rounded-3xl border-0 shadow-lg shadow-slate-100/80 hover:shadow-xl hover:-translate-y-1 transition-all duration-300 cursor-pointer" 
          data-testid="stat-clienti-donna-mese"
          onClick={() => setClientiMeseDialog({ open: true, genere: 'F' })}
        >
          <CardContent className="p-6">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm font-medium text-slate-400 uppercase tracking-wide">Clienti DONNA mese</p>
                <p className="text-4xl font-bold text-slate-800 mt-2 tracking-tight">
                  {clientiMesePerGenere.donna || 0}
                </p>
                <p className="text-xs text-pink-600 mt-1 flex items-center gap-1">
                  Vedi lista <ChevronRight className="w-3 h-3" />
                </p>
              </div>
              <div className="w-14 h-14 rounded-2xl bg-gradient-to-br from-pink-500 to-rose-500 flex items-center justify-center shadow-lg shadow-pink-500/30">
                <User className="w-7 h-7 text-white" />
              </div>
            </div>
          </CardContent>
        </Card>

        {/* Scorte Basse - Click apre report scorte */}
        <Card 
          className="bg-white rounded-3xl border-0 shadow-lg shadow-slate-100/80 hover:shadow-xl hover:-translate-y-1 transition-all duration-300 cursor-pointer" 
          data-testid="stat-low-stock"
          onClick={generateScorteReport}
        >
          <CardContent className="p-6">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm font-medium text-slate-400 uppercase tracking-wide">Scorte Basse</p>
                <p className={`text-4xl font-bold mt-2 tracking-tight ${stats?.scorte_basse > 0 ? 'text-red-500' : 'text-slate-800'}`}>
                  {stats?.scorte_basse || 0}
                </p>
                <p className="text-xs text-orange-600 mt-1 flex items-center gap-1">
                  {generatingReport ? "Caricamento..." : "Report Settimanale"} <ChevronRight className="w-3 h-3" />
                </p>
              </div>
              <div className={`w-14 h-14 rounded-2xl flex items-center justify-center shadow-lg ${stats?.scorte_basse > 0 ? 'bg-gradient-to-br from-red-500 to-orange-500 shadow-red-500/30' : 'bg-gradient-to-br from-orange-400 to-amber-400 shadow-orange-500/30'}`}>
                <Package className="w-7 h-7 text-white" />
              </div>
            </div>
          </CardContent>
        </Card>

        {/* Card Attive - Riepilogo protetto da PIN */}
        <Card
          className="bg-white rounded-3xl border-0 shadow-lg shadow-slate-100/80 hover:shadow-xl hover:-translate-y-1 transition-all duration-300 cursor-pointer"
          data-testid="stat-card-attive"
          onClick={openCardsRiepilogo}
        >
          <CardContent className="p-6">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm font-medium text-slate-400 uppercase tracking-wide">Card Attive</p>
                <p className="text-4xl font-bold mt-2 tracking-tight text-emerald-600">
                  •••
                </p>
                <p className="text-xs text-emerald-600 mt-1 flex items-center gap-1">
                  Riepilogo (PIN) <ChevronRight className="w-3 h-3" />
                </p>
              </div>
              <div className="w-14 h-14 rounded-2xl flex items-center justify-center shadow-lg bg-gradient-to-br from-emerald-500 to-teal-500 shadow-emerald-500/30">
                <Wallet className="w-7 h-7 text-white" />
              </div>
            </div>
          </CardContent>
        </Card>
      </div>

      {/* ────────── SOGLIE ERP integrate dentro Obiettivo Mensile (vedi sotto) ────────── */}


      {/* CARD GIORNO — Vendute & Ricaricate per Operatore */}
      {(stats?.card_vendute_oggi > 0 || stats?.card_ricariche_oggi > 0) && (
        <Card className="border-0 shadow-lg rounded-3xl overflow-hidden bg-gradient-to-br from-pink-500 via-fuchsia-500 to-purple-600" data-testid="card-day-summary">
          <CardContent className="p-6 text-white">
            <div className="flex flex-wrap items-center justify-between gap-4 mb-4">
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 rounded-2xl bg-white/20 flex items-center justify-center">
                  <CreditCard className="w-6 h-6" />
                </div>
                <div>
                  <p className="text-sm font-medium text-pink-100 uppercase tracking-wide">Card Vendute & Ricaricate Oggi</p>
                  <p className="text-lg text-pink-50">Monitoraggio incassi per operatore</p>
                </div>
              </div>
              <div className="flex gap-3">
                <div className="bg-white/20 rounded-xl px-4 py-2 text-center min-w-[110px]">
                  <p className="text-2xl font-bold">{stats.card_vendute_oggi || 0}</p>
                  <p className="text-[10px] text-pink-100">Card vendute</p>
                  <p className="text-xs font-semibold">€{(stats.card_vendute_importo_oggi || 0).toFixed(0)}</p>
                </div>
                <div className="bg-white/20 rounded-xl px-4 py-2 text-center min-w-[110px]">
                  <p className="text-2xl font-bold">{stats.card_ricariche_oggi || 0}</p>
                  <p className="text-[10px] text-pink-100">Ricariche</p>
                  <p className="text-xs font-semibold">€{(stats.card_ricariche_importo_oggi || 0).toFixed(0)}</p>
                </div>
              </div>
            </div>
            {stats?.card_per_operatore_oggi?.length > 0 && (
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3" data-testid="card-day-per-operatore">
                {stats.card_per_operatore_oggi.map((op) => (
                  <div key={op.operatore} className="bg-white/15 backdrop-blur-sm rounded-xl px-3 py-2 border border-white/20">
                    <p className="text-sm font-semibold flex items-center gap-1.5">
                      <span className="inline-flex items-center justify-center w-6 h-6 rounded-full bg-white/30 text-xs font-bold">
                        {op.operatore.charAt(0).toUpperCase()}
                      </span>
                      {op.operatore}
                    </p>
                    <div className="flex justify-between text-xs mt-1 text-pink-50">
                      <span>{op.vendute_count} vendute · €{op.vendute_importo.toFixed(0)}</span>
                      <span>{op.ricariche_count} ric. · €{op.ricariche_importo.toFixed(0)}</span>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </CardContent>
        </Card>
      )}

      {/* PREVISIONALE INCASSO GIORNALIERO */}
      <Card className="border-0 shadow-lg rounded-3xl overflow-hidden bg-gradient-to-br from-cyan-500 to-blue-600">
        <CardContent className="p-6 text-white">
          {/* Header con totale appuntamenti */}
          <div className="flex items-center justify-between mb-4">
            <div className="flex items-center gap-3">
              <div className="w-12 h-12 rounded-2xl bg-white/20 flex items-center justify-center">
                <TrendingUp className="w-6 h-6" />
              </div>
              <div>
                <p className="text-sm font-medium text-cyan-100 uppercase tracking-wide">Previsionale Oggi</p>
                <p className="text-3xl font-bold">€{previsionaleData.totale_giornata_previsto.toFixed(0)}</p>
                <p className="text-xs text-cyan-200">
                  Basato su {previsionaleData.totale_appuntamenti || 0} appuntamenti
                </p>
              </div>
            </div>
            {previsionaleData.obiettivo_giornaliero > 0 && (
              <div className="text-right">
                <p className="text-sm text-cyan-100">Obiettivo giornaliero</p>
                <p className="text-xl font-semibold">€{previsionaleData.obiettivo_giornaliero.toFixed(0)}</p>
                <p className="text-[10px] text-cyan-200/70">
                  (mensile ÷ {previsionaleData.giorni_lavorativi_mese || 26} giorni)
                </p>
              </div>
            )}
          </div>
          
          {/* Incassato e Da incassare */}
          <div className="grid grid-cols-2 gap-4 mt-4">
            <div className="bg-green-500/30 border border-green-400/50 rounded-xl p-4 text-center">
              <p className="text-3xl font-bold">€{previsionaleData.incasso_reale.toFixed(0)}</p>
              <p className="text-sm text-green-100 mt-1">✓ Incassato</p>
              <p className="text-[10px] text-green-200/70">(contanti + carta + ricariche)</p>
            </div>
            <div className="bg-white/10 border border-white/20 rounded-xl p-4 text-center">
              <p className="text-3xl font-bold">€{previsionaleData.previsionale.toFixed(0)}</p>
              <p className="text-sm text-cyan-100 mt-1">Da incassare</p>
              <p className="text-[10px] text-cyan-200/70">({previsionaleData.appuntamenti_da_incassare} appuntamenti)</p>
            </div>
          </div>
          
          {/* Info Card Prepagata se usata */}
          {previsionaleData.incasso_card_utilizzata > 0 && (
            <div className="mt-3 bg-purple-500/20 border border-purple-400/30 rounded-lg p-2 text-center">
              <p className="text-xs text-purple-200">
                💳 €{previsionaleData.incasso_card_utilizzata.toFixed(0)} pagati con Card Prepagata
                <span className="opacity-70 ml-1">(già conteggiati alla ricarica)</span>
              </p>
            </div>
          )}
          
          {/* Quanto manca all'obiettivo */}
          {previsionaleData.obiettivo_giornaliero > 0 && (
            <div className="mt-4">
              <div className="flex justify-between items-center mb-2">
                <span className="text-sm text-cyan-100">Progresso obiettivo</span>
                <span className="font-bold text-lg">{previsionaleData.percentuale_obiettivo.toFixed(0)}%</span>
              </div>
              <div className="h-3 bg-white/20 rounded-full overflow-hidden">
                <div 
                  className={`h-full rounded-full transition-all ${previsionaleData.percentuale_obiettivo >= 100 ? 'bg-green-400' : 'bg-white'}`}
                  style={{ width: `${Math.min(100, previsionaleData.percentuale_obiettivo)}%` }}
                />
              </div>
              {/* Quanto manca */}
              {previsionaleData.totale_giornata_previsto < previsionaleData.obiettivo_giornaliero ? (
                <div className="mt-3 text-center bg-orange-500/30 border border-orange-400/50 rounded-lg p-2">
                  <p className="text-sm">
                    Mancano <span className="font-bold text-lg">€{(previsionaleData.obiettivo_giornaliero - previsionaleData.totale_giornata_previsto).toFixed(0)}</span> all'obiettivo
                  </p>
                </div>
              ) : (
                <div className="mt-3 text-center bg-green-500/30 border border-green-400/50 rounded-lg p-2">
                  <p className="text-sm">
                    🎉 Obiettivo raggiunto! <span className="font-bold">+€{(previsionaleData.totale_giornata_previsto - previsionaleData.obiettivo_giornaliero).toFixed(0)}</span> extra
                  </p>
                </div>
              )}
            </div>
          )}
          
          {/* Info chiusure e pulsante report */}
          <div className="mt-4 flex items-center justify-between">
            <div className="text-xs text-cyan-200/70">
              {previsionaleData.chiusure_straordinarie_mese > 0 && (
                <span>⚠️ {previsionaleData.chiusure_straordinarie_mese} chiusure straordinarie questo mese</span>
              )}
            </div>
            <Button 
              variant="ghost" 
              size="sm" 
              className="text-white hover:bg-white/20 text-xs"
              onClick={fetchReportMensile}
              data-testid="btn-report-mensile"
            >
              <FileSpreadsheet className="w-4 h-4 mr-1" />
              Report Mese
            </Button>
          </div>
        </CardContent>
      </Card>

      {/* Obiettivo Mensile + Compleanni Row */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        {/* OBIETTIVO MENSILE — con soglie ERP integrate + pianificazione futura */}
        <Card className="border-0 shadow-lg rounded-3xl overflow-hidden lg:col-span-2" data-testid="obiettivo-mensile-erp">
          <CardHeader className="bg-gradient-to-r from-amber-500 via-orange-500 to-red-500 text-white pb-4">
            <div className="flex items-center justify-between flex-wrap gap-2">
              <CardTitle className="text-lg font-semibold flex items-center gap-2">
                <Target className="w-5 h-5" />
                Obiettivo Mensile & Soglie ERP
                {obiettiviMensili[meseSelezionato] && (
                  <span className="ml-1 text-[10px] bg-white/25 rounded-full px-2 py-0.5 uppercase tracking-wider">Pianificato</span>
                )}
              </CardTitle>
              <div className="flex items-center gap-2 flex-wrap">
                {/* Selettore mese con navigazione ← → per fatturato storico */}
                {obiettivoUnlocked && (
                  <div className="flex items-center gap-1 bg-white/15 rounded-lg p-0.5 backdrop-blur-sm">
                    <button
                      type="button"
                      onClick={() => {
                        const [y, m] = meseSelezionato.split('-').map(Number);
                        const prev = new Date(y, m - 2, 1);
                        const ym = format(prev, 'yyyy-MM');
                        setMeseSelezionato(ym);
                        refetchSoglie(undefined, ym);
                      }}
                      className="text-white hover:bg-white/20 rounded p-1"
                      title="Mese precedente"
                      data-testid="btn-mese-prec"
                    >
                      ←
                    </button>
                    <select
                      value={meseSelezionato}
                      onChange={(e) => { setMeseSelezionato(e.target.value); refetchSoglie(undefined, e.target.value); }}
                      className="text-xs bg-transparent text-white border-0 rounded px-1.5 py-1 focus:ring-2 focus:ring-white/50 min-w-[120px]"
                      data-testid="mese-selettore"
                    >
                      {(() => {
                        // Genera opzioni: 24 mesi indietro (storico completo) + corrente + 12 mesi futuri
                        const opts = [];
                        const now = new Date();
                        for (let i = -24; i <= 12; i++) {
                          const d = new Date(now.getFullYear(), now.getMonth() + i, 1);
                          const ym = format(d, 'yyyy-MM');
                          const isCorrente = ym === format(now, 'yyyy-MM');
                          opts.push(
                            <option key={ym} value={ym} className="text-slate-800">
                              {format(d, 'MMMM yyyy', { locale: it })}{isCorrente ? ' •' : ''}{obiettiviMensili[ym] ? ' ✓' : ''}
                            </option>
                          );
                        }
                        return opts;
                      })()}
                    </select>
                    <button
                      type="button"
                      onClick={() => {
                        const [y, m] = meseSelezionato.split('-').map(Number);
                        const next = new Date(y, m, 1);
                        const ym = format(next, 'yyyy-MM');
                        setMeseSelezionato(ym);
                        refetchSoglie(undefined, ym);
                      }}
                      className="text-white hover:bg-white/20 rounded p-1"
                      title="Mese successivo"
                      data-testid="btn-mese-succ"
                    >
                      →
                    </button>
                    {meseSelezionato !== format(new Date(), 'yyyy-MM') && (
                      <button
                        type="button"
                        onClick={() => {
                          const ym = format(new Date(), 'yyyy-MM');
                          setMeseSelezionato(ym);
                          refetchSoglie(undefined, ym);
                        }}
                        className="text-[10px] text-white bg-white/20 hover:bg-white/30 rounded px-1.5 py-0.5 ml-0.5"
                        title="Torna al mese corrente"
                        data-testid="btn-mese-oggi"
                      >
                        Oggi
                      </button>
                    )}
                    {obiettivoUnlocked && (
                      <button
                        type="button"
                        onClick={async () => {
                          try {
                            const resp = await axios.get(
                              `${API}/analytics/report-mensile-pdf?mese=${meseSelezionato}`,
                              { headers: { Authorization: `Bearer ${token}` }, responseType: 'blob' }
                            );
                            const url = window.URL.createObjectURL(new Blob([resp.data], { type: 'application/pdf' }));
                            const link = document.createElement('a');
                            link.href = url;
                            link.download = `report_${meseSelezionato}.pdf`;
                            document.body.appendChild(link);
                            link.click();
                            link.remove();
                            window.URL.revokeObjectURL(url);
                            toast.success(`Report ${meseSelezionato} scaricato`);
                          } catch {
                            toast.error("Errore generazione report");
                          }
                        }}
                        className="text-[10px] text-white bg-white/20 hover:bg-white/30 rounded px-2 py-0.5 ml-1"
                        title="Scarica PDF report mese"
                        data-testid="btn-report-pdf"
                      >
                        📄 PDF
                      </button>
                    )}
                  </div>
                )}
                {obiettivoUnlocked && (
                  <>
                    <Button
                      variant="ghost"
                      size="sm"
                      className="text-white hover:bg-white/20 h-8"
                      onClick={() => {
                        // Precompila con dati mese o defaults
                        const existing = obiettiviMensili[meseSelezionato];
                        setPianifMese(meseSelezionato);
                        setPianifForm({
                          obiettivo: existing?.obiettivo || obiettivoMensile || 0,
                          soglie: existing?.soglie || {
                            ordine_tecnico: 18, rivendita: 12, monouso: 5,
                            utenze: 8, abbonamenti: 4, totale_spese: 60
                          }
                        });
                        setPianifDialogOpen(true);
                      }}
                      data-testid="btn-pianifica-mese"
                      title="Pianifica obiettivo e soglie per il mese selezionato"
                    >
                      <span className="text-base">📅</span>
                      <span className="hidden sm:inline text-xs ml-1">Pianifica</span>
                    </Button>
                    <Button
                      variant="ghost"
                      size="sm"
                      className="text-white hover:bg-white/20 h-8"
                      onClick={() => setShowObiettivoDialog(true)}
                      data-testid="btn-modifica-obiettivo-globale"
                      title="Modifica obiettivo globale e PIN"
                    >
                      <Eye className="w-4 h-4" />
                    </Button>
                    <Button
                      variant="ghost"
                      size="sm"
                      className="text-white hover:bg-white/20 h-8"
                      onClick={lockObiettivo}
                      data-testid="btn-lock-obiettivo"
                      title="Blocca visualizzazione (richiede PIN)"
                    >
                      <Lock className="w-4 h-4" />
                    </Button>
                  </>
                )}
                {!obiettivoUnlocked && (
                  <Button
                    variant="ghost"
                    size="sm"
                    className="text-white hover:bg-white/20"
                    onClick={() => setShowObiettivoDialog(true)}
                  >
                    <Lock className="w-4 h-4" />
                  </Button>
                )}
              </div>
            </div>
          </CardHeader>
          <CardContent className="p-6">
            {/* Blocco PIN se richiesto e non ancora sbloccato */}
            {obiettivoPin && !obiettivoUnlocked ? (
              <div className="text-center py-8 space-y-4" data-testid="obiettivo-pin-block">
                <Lock className="w-14 h-14 mx-auto text-slate-300" />
                <div>
                  <p className="font-semibold text-slate-800">Sezione protetta</p>
                  <p className="text-sm text-slate-500">Inserisci il PIN per visualizzare gli obiettivi e le soglie ERP</p>
                </div>
                <div className="flex gap-2 max-w-[240px] mx-auto">
                  <Input
                    type="password"
                    value={pinInput}
                    onChange={(e) => setPinInput(e.target.value)}
                    placeholder="PIN"
                    className="text-center"
                    maxLength={6}
                    onKeyDown={(e) => e.key === 'Enter' && verificaPin()}
                    data-testid="input-pin-obiettivo"
                  />
                  <Button onClick={verificaPin} className="bg-amber-500 hover:bg-amber-600" data-testid="btn-verifica-pin">
                    <Unlock className="w-4 h-4" />
                  </Button>
                </div>
                <p className="text-[10px] text-slate-400">
                  Puoi impostare/modificare il PIN da <strong>Impostazioni → Salone</strong>
                </p>
              </div>
            ) : (
              <div className="space-y-5">
                {/* Riepilogo obiettivo del mese selezionato */}
                {(() => {
                  const monthPlan = obiettiviMensili[meseSelezionato];
                  const targetMese = monthPlan?.obiettivo || (meseSelezionato === format(new Date(), 'yyyy-MM') ? obiettivoMensile : 0);
                  const incassoMese = spesevsSoglie?.mese === meseSelezionato ? spesevsSoglie.incasso_mese : incassoMensile;
                  const pctObiettivo = targetMese > 0 ? (incassoMese / targetMese) * 100 : 0;
                  const isMeseCorrente = meseSelezionato === format(new Date(), 'yyyy-MM');
                  return (
                    <>
                      <div className="flex items-end justify-between flex-wrap gap-2">
                        <div>
                          <p className="text-xs uppercase tracking-wide text-slate-500">
                            {isMeseCorrente ? 'Incasso Mese Corrente' : `Incasso ${format(new Date(meseSelezionato + '-01'), 'MMMM yyyy', { locale: it })}`}
                          </p>
                          <p className="text-3xl font-black text-slate-800">€{incassoMese.toFixed(0)}</p>
                        </div>
                        <div className="text-right">
                          <p className="text-xs uppercase tracking-wide text-slate-500">Obiettivo</p>
                          <p className="text-xl font-bold text-amber-600">
                            €{targetMese > 0 ? targetMese.toFixed(0) : '—'}
                          </p>
                          {monthPlan && (
                            <span className="text-[10px] bg-amber-100 text-amber-700 rounded-full px-2 py-0.5 font-semibold">
                              PIANIFICATO
                            </span>
                          )}
                        </div>
                      </div>
                      {targetMese > 0 && (
                        <div className="space-y-1">
                          <div className="flex justify-between text-xs">
                            <span className="text-slate-500">Progresso</span>
                            <span className={`font-bold ${pctObiettivo >= 100 ? 'text-emerald-600' : 'text-amber-600'}`}>
                              {pctObiettivo.toFixed(1)}%
                            </span>
                          </div>
                          <Progress value={Math.min(100, pctObiettivo)} className="h-3" />
                          {isMeseCorrente && (
                            pctObiettivo >= 100 ? (
                              <div className="flex items-center gap-2 p-2 mt-2 bg-emerald-50 rounded-lg text-emerald-700">
                                <CheckCircle2 className="w-4 h-4" />
                                <span className="text-xs font-medium">Obiettivo raggiunto! 🎉</span>
                              </div>
                            ) : (
                              <p className="text-xs text-slate-500 text-center mt-1">
                                Mancano <strong className="text-amber-600">€{(targetMese - incassoMese).toFixed(0)}</strong> al target
                              </p>
                            )
                          )}
                        </div>
                      )}
                    </>
                  );
                })()}

                {/* Griglia Soglie ERP del mese */}
                {spesevsSoglie && spesevsSoglie.mese === meseSelezionato && (
                  <div className="border-t pt-4">
                    <div className="flex items-center justify-between mb-3 flex-wrap gap-2">
                      <h3 className="text-sm font-bold text-slate-800 uppercase tracking-wide flex items-center gap-2">
                        🎯 Soglie ERP per Categoria
                      </h3>
                      {spesevsSoglie.obiettivo_fatturato_annuo > 0 && (
                        <button
                          onClick={() => {
                            const newMode = soglieMode === 'reale' ? 'obiettivo' : 'reale';
                            setSoglieMode(newMode);
                            refetchSoglie(newMode);
                          }}
                          className="text-[10px] bg-slate-100 hover:bg-slate-200 rounded-lg px-2 py-1 font-medium"
                          data-testid="toggle-modalita-soglie-integrato"
                        >
                          vs {soglieMode === 'reale' ? '📊 Reale' : '🎯 Obiettivo'}
                        </button>
                      )}
                    </div>
                    <div className="grid grid-cols-2 sm:grid-cols-3 gap-2">
                      {(spesevsSoglie.categorie || []).map(d => {
                        const speso = d.importo;
                        const budget = d.importo_max;
                        const critico = d.livello === 'warning';
                        const over = d.livello === 'critico';
                        const barColor = over ? 'bg-red-500' : critico ? 'bg-amber-500' : 'bg-emerald-500';
                        const bgAccent = over ? 'bg-red-50 border-red-200' : critico ? 'bg-amber-50 border-amber-200' : 'bg-emerald-50 border-emerald-200';
                        return (
                          <div key={d.chiave} className={`rounded-lg p-2 border ${bgAccent}`} data-testid={`obiettivo-cat-${d.chiave}`}>
                            <div className="flex items-start justify-between mb-1">
                              <div className="min-w-0">
                                <p className="text-[10px] font-bold text-slate-800 truncate uppercase">{d.nome}</p>
                                <p className="text-[9px] text-slate-500">{d.soglia_pct}% · €{budget?.toFixed(0)}</p>
                              </div>
                              <span className={`text-sm font-black shrink-0 ml-1 ${over ? 'text-red-700' : critico ? 'text-amber-700' : 'text-emerald-700'}`}>
                                {d.pct_attuale}%
                              </span>
                            </div>
                            <div className="h-1.5 bg-white/70 rounded-full overflow-hidden">
                              <div className={`h-full ${barColor}`} style={{ width: `${Math.min(100, (speso / (budget || 1)) * 100)}%` }} />
                            </div>
                            <p className="text-[9px] text-slate-500 mt-1">
                              €{speso?.toFixed(0)}
                              {over ? <span className="text-red-600 font-bold ml-1">(+€{(speso - budget).toFixed(0)})</span> : null}
                            </p>
                          </div>
                        );
                      })}
                    </div>
                    {(!spesevsSoglie.categorie || spesevsSoglie.categorie.length === 0) && (
                      <p className="text-center text-xs text-slate-400 py-4">
                        Nessun dato spese per il mese. Le soglie saranno calcolate quando registri le spese.
                      </p>
                    )}
                  </div>
                )}

                {/* ────────── MINI CALENDARIO 12 MESI — Piano vs Reale ────────── */}
                {pianAnnuale && (
                  <div className="border-t pt-4" data-testid="mini-calendario-annuale">
                    <div className="flex items-center justify-between mb-3 flex-wrap gap-2">
                      <div className="flex items-center gap-2">
                        <h3 className="text-sm font-bold text-slate-800 uppercase tracking-wide">
                          📅 Piano Annuale {pianAnnuale.anno}
                        </h3>
                        <div className="flex gap-1">
                          <button
                            onClick={() => { const y = pianAnnuale.anno - 1; setAnnoPianificazione(y); fetchPianificazioneAnnuale(y); }}
                            className="text-xs px-2 py-0.5 bg-slate-100 hover:bg-slate-200 rounded"
                            data-testid="btn-anno-prec"
                          >←</button>
                          <button
                            onClick={() => { const y = pianAnnuale.anno + 1; setAnnoPianificazione(y); fetchPianificazioneAnnuale(y); }}
                            className="text-xs px-2 py-0.5 bg-slate-100 hover:bg-slate-200 rounded"
                            data-testid="btn-anno-succ"
                          >→</button>
                        </div>
                      </div>
                      <div className="flex gap-2 text-[10px]">
                        <span className="flex items-center gap-1"><span className="w-2 h-2 rounded-full bg-emerald-500 inline-block"/>Raggiunto {pianAnnuale.mesi_raggiunti}</span>
                        <span className="flex items-center gap-1"><span className="w-2 h-2 rounded-full bg-red-500 inline-block"/>Mancato {pianAnnuale.mesi_mancati}</span>
                        <span className="flex items-center gap-1"><span className="w-2 h-2 rounded-full bg-blue-500 inline-block"/>Pianificati {pianAnnuale.mesi_pianificati}</span>
                      </div>
                    </div>

                    <div className="grid grid-cols-3 sm:grid-cols-4 lg:grid-cols-6 gap-2">
                      {pianAnnuale.mesi.map(m => {
                        const nomeMese = format(new Date(m.mese + '-01'), 'MMM', { locale: it });
                        const isMeseCorrente = m.stato === 'in_corso';
                        const isSelected = m.mese === meseSelezionato;
                        const bg = m.stato === 'raggiunto' ? 'bg-emerald-50 border-emerald-300'
                          : m.stato === 'mancato' ? 'bg-red-50 border-red-300'
                          : m.stato === 'in_corso' ? 'bg-blue-50 border-blue-400 ring-2 ring-blue-200'
                          : m.stato === 'futuro' && m.pianificato ? 'bg-amber-50 border-amber-300'
                          : m.stato === 'futuro' ? 'bg-slate-50 border-slate-200'
                          : 'bg-white border-slate-200';
                        const dot = m.stato === 'raggiunto' ? 'bg-emerald-500'
                          : m.stato === 'mancato' ? 'bg-red-500'
                          : m.stato === 'in_corso' ? 'bg-blue-500 animate-pulse'
                          : m.pianificato ? 'bg-amber-500'
                          : 'bg-slate-300';
                        return (
                          <button
                            key={m.mese}
                            onClick={() => {
                              setMeseSelezionato(m.mese);
                              refetchSoglie(undefined, m.mese);
                              // Se clicco un mese futuro non pianificato → apri direttamente il dialog
                              if (m.stato === 'futuro' && !m.pianificato) {
                                setPianifMese(m.mese);
                                setPianifForm({
                                  obiettivo: obiettivoMensile || 0,
                                  soglie: { ordine_tecnico: 18, rivendita: 12, monouso: 5, utenze: 8, abbonamenti: 4, totale_spese: 60 }
                                });
                                setPianifDialogOpen(true);
                              }
                            }}
                            className={`p-2 border rounded-lg text-left transition hover:shadow-md ${bg} ${isSelected ? 'ring-2 ring-amber-400 shadow' : ''}`}
                            data-testid={`calendario-mese-${m.mese}`}
                            title={m.pianificato
                              ? `${nomeMese} - Obiettivo €${m.obiettivo} / Incasso €${m.incasso} (${m.pct_completamento}%)`
                              : `${nomeMese} - Nessun piano`}
                          >
                            <div className="flex items-center justify-between">
                              <span className="text-xs font-bold text-slate-800 capitalize">{nomeMese}</span>
                              <span className={`w-2 h-2 rounded-full ${dot}`} />
                            </div>
                            {m.pianificato ? (
                              <>
                                <p className="text-[10px] text-slate-500 mt-1">Obj €{m.obiettivo.toFixed(0)}</p>
                                <p className={`text-[10px] font-semibold ${
                                  m.stato === 'raggiunto' ? 'text-emerald-700'
                                  : m.stato === 'mancato' ? 'text-red-700'
                                  : m.stato === 'in_corso' ? 'text-blue-700'
                                  : 'text-amber-700'
                                }`}>
                                  {m.stato === 'raggiunto' ? '✓ Raggiunto'
                                    : m.stato === 'mancato' ? '✗ Mancato'
                                    : m.stato === 'in_corso' ? `${m.pct_completamento}%`
                                    : '📅 Piano'}
                                </p>
                              </>
                            ) : (
                              <p className="text-[10px] text-slate-400 mt-1">
                                {m.incasso > 0 ? `€${m.incasso.toFixed(0)}` : (m.stato === 'futuro' ? 'clic per pianificare' : '—')}
                              </p>
                            )}
                          </button>
                        );
                      })}
                    </div>

                    {/* Riepilogo annuale (Piano vs Reale) */}
                    {pianAnnuale.mesi_pianificati > 0 && (
                      <div className="mt-3 grid grid-cols-3 gap-2 pt-3 border-t border-slate-100">
                        <div className="text-center">
                          <p className="text-[10px] text-slate-500 uppercase">Obiettivo Annuo</p>
                          <p className="text-sm font-black text-slate-800">€{pianAnnuale.totale_obiettivo.toLocaleString('it-IT')}</p>
                        </div>
                        <div className="text-center">
                          <p className="text-[10px] text-slate-500 uppercase">Incasso Reale</p>
                          <p className="text-sm font-black text-blue-700">€{pianAnnuale.totale_incasso.toLocaleString('it-IT')}</p>
                        </div>
                        <div className="text-center">
                          <p className="text-[10px] text-slate-500 uppercase">Delta</p>
                          <p className={`text-sm font-black ${pianAnnuale.delta_annuale >= 0 ? 'text-emerald-700' : 'text-red-700'}`}>
                            {pianAnnuale.delta_annuale >= 0 ? '+' : ''}€{pianAnnuale.delta_annuale.toLocaleString('it-IT')}
                            <span className="text-[10px] ml-1 font-normal">({pianAnnuale.pct_annuale}%)</span>
                          </p>
                        </div>
                      </div>
                    )}

                    {/* ════════ BAR CHART 12 MESI — Incasso Reale vs Obiettivo ════════ */}
                    <div className="mt-4 pt-3 border-t border-slate-100" data-testid="bar-chart-storico">
                      <p className="text-xs font-semibold text-slate-600 uppercase tracking-wide mb-2">
                        📊 Fatturato storico 12 mesi (Reale vs Obiettivo)
                      </p>
                      <ResponsiveContainer width="100%" height={180}>
                        <BarChart
                          data={pianAnnuale.mesi.map(m => ({
                            mese: format(new Date(m.mese + '-01'), 'MMM', { locale: it }),
                            Incasso: m.incasso,
                            Obiettivo: m.obiettivo
                          }))}
                          margin={{ top: 5, right: 8, bottom: 0, left: 0 }}
                        >
                          <CartesianGrid strokeDasharray="3 3" stroke="#e2e8f0" />
                          <XAxis dataKey="mese" tick={{ fontSize: 10 }} />
                          <YAxis tick={{ fontSize: 10 }} tickFormatter={(v) => v >= 1000 ? `${(v/1000).toFixed(0)}k` : v} />
                          <Tooltip
                            formatter={(v) => `€${(v || 0).toLocaleString('it-IT')}`}
                            labelStyle={{ fontWeight: 'bold' }}
                            contentStyle={{ fontSize: 12, borderRadius: 8 }}
                          />
                          <Legend wrapperStyle={{ fontSize: 11 }} />
                          <Bar dataKey="Obiettivo" fill="#fbbf24" radius={[4, 4, 0, 0]} />
                          <Bar dataKey="Incasso" fill="#3b82f6" radius={[4, 4, 0, 0]} />
                        </BarChart>
                      </ResponsiveContainer>
                    </div>
                  </div>
                )}
              </div>
            )}
          </CardContent>
        </Card>

        {/* COMPLEANNI */}
        <Card className="border-0 shadow-lg rounded-3xl overflow-hidden lg:col-span-2">
          <CardHeader className="bg-gradient-to-r from-pink-500 to-rose-500 text-white pb-4">
            <div className="flex items-center justify-between">
              <CardTitle className="text-lg font-semibold flex items-center gap-2">
                <Cake className="w-5 h-5" />
                Compleanni
                {compleanniOggi.length > 0 && (
                  <span className="bg-white text-pink-600 text-xs px-2 py-0.5 rounded-full font-bold">
                    {compleanniOggi.length} OGGI
                  </span>
                )}
              </CardTitle>
              <Button 
                variant="ghost" 
                size="sm" 
                className="text-white hover:bg-white/20"
                onClick={() => setShowCompleanniDialog(true)}
              >
                Vedi tutti
              </Button>
            </div>
          </CardHeader>
          <CardContent className="p-6">
            {/* Filtri */}
            <div className="flex gap-2 mb-4">
              {["oggi", "settimana", "mese"].map(f => (
                <button
                  key={f}
                  onClick={() => setCompleanniFilter(f)}
                  className={`px-3 py-1 rounded-full text-sm transition-colors ${
                    compleanniFilter === f 
                      ? "bg-pink-100 text-pink-700 font-medium" 
                      : "bg-slate-100 text-slate-600 hover:bg-slate-200"
                  }`}
                >
                  {f === "oggi" ? "Oggi" : f === "settimana" ? "Settimana" : "Mese"}
                </button>
              ))}
            </div>

            {/* Lista compleanni */}
            <div className="space-y-3 max-h-[200px] overflow-y-auto">
              {getCompeleanniFiltrati().length > 0 ? (
                getCompeleanniFiltrati().slice(0, 5).map(cliente => (
                  <div 
                    key={cliente.id}
                    className={`flex items-center gap-3 p-3 rounded-xl transition-colors cursor-pointer ${
                      cliente.giorniMancanti === 0 
                        ? "bg-pink-50 border border-pink-200" 
                        : "bg-slate-50 hover:bg-slate-100"
                    }`}
                    onClick={() => navigate('/clienti')}
                  >
                    <div className={`w-10 h-10 rounded-full flex items-center justify-center ${
                      cliente.giorniMancanti === 0 ? "bg-pink-500" : "bg-slate-300"
                    }`}>
                      {cliente.giorniMancanti === 0 ? (
                        <Gift className="w-5 h-5 text-white" />
                      ) : (
                        <Cake className="w-5 h-5 text-white" />
                      )}
                    </div>
                    <div className="flex-1">
                      <p className="font-medium text-slate-800">
                        {cliente.nome} {cliente.cognome}
                      </p>
                      <p className="text-xs text-slate-500">
                        {cliente.giorniMancanti === 0 
                          ? `Compie ${cliente.eta} anni OGGI! 🎂` 
                          : `Tra ${cliente.giorniMancanti} giorni (${format(cliente.prossimoCompleanno, "d MMM", { locale: it })})`
                        }
                      </p>
                    </div>
                    {cliente.telefono && (
                      <Button 
                        variant="ghost" 
                        size="sm"
                        onClick={(e) => {
                          e.stopPropagation();
                          window.open(`https://wa.me/${cliente.telefono.replace(/\s/g, "")}?text=Tanti%20auguri%20di%20buon%20compleanno!%20🎂`, "_blank");
                        }}
                      >
                        <MessageCircle className="w-4 h-4 text-green-600" />
                      </Button>
                    )}
                  </div>
                ))
              ) : (
                <div className="text-center py-6 text-slate-400">
                  <Cake className="w-10 h-10 mx-auto mb-2 opacity-50" />
                  <p>Nessun compleanno {compleanniFilter === "oggi" ? "oggi" : `questa ${compleanniFilter}`}</p>
                </div>
              )}
            </div>
          </CardContent>
        </Card>
      </div>

      {/* Main Content Grid */}
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        {/* Today's Schedule */}
        <Card className="lg:col-span-2 border-0 shadow-lg rounded-3xl" data-testid="today-schedule">
          <CardHeader className="pb-4">
            <div className="flex items-center justify-between">
              <CardTitle className="text-lg font-semibold text-slate-800" style={{ fontFamily: 'Playfair Display, serif' }}>
                Appuntamenti di Oggi
              </CardTitle>
              <Button 
                onClick={() => navigate('/agenda')} 
                variant="outline" 
                size="sm"
                className="text-blue-600 border-blue-200 hover:bg-blue-50"
              >
                Vedi Tutti
              </Button>
            </div>
          </CardHeader>
          <CardContent>
            {stats?.prossimi_appuntamenti?.length > 0 ? (
              <div className="space-y-3">
                {stats.prossimi_appuntamenti.map((app, index) => (
                  <div 
                    key={app.id} 
                    className="flex items-center gap-4 p-4 rounded-xl bg-slate-50 hover:bg-slate-100 transition-colors cursor-pointer"
                    onClick={() => navigate('/agenda')}
                  >
                    <div className="w-14 h-14 rounded-xl bg-blue-600 flex flex-col items-center justify-center text-white">
                      <span className="text-xs font-medium">{app.ora}</span>
                    </div>
                    <div className="flex-1">
                      <p className="font-semibold text-slate-800">{app.cliente_nome}</p>
                      <p className="text-sm text-slate-500">
                        {app.servizi.map(s => s.nome).join(', ')}
                      </p>
                    </div>
                    <div className="text-right">
                      <p className="font-bold text-blue-600">€{app.totale.toFixed(2)}</p>
                      <span className={`text-xs px-2 py-0.5 rounded-full ${
                        app.stato === 'confermato' ? 'bg-blue-100 text-blue-700' : 'bg-green-100 text-green-700'
                      }`}>
                        {app.stato}
                      </span>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div className="text-center py-8">
                <Calendar className="w-12 h-12 mx-auto text-slate-300 mb-4" />
                <p className="text-slate-500 mb-4">Nessun appuntamento per oggi</p>
                <Button 
                  onClick={() => navigate('/agenda')}
                  className="bg-blue-600 hover:bg-blue-700"
                >
                  <Plus className="w-4 h-4 mr-2" />
                  Nuovo Appuntamento
                </Button>
              </div>
            )}
          </CardContent>
        </Card>

        {/* Quick Actions */}
        <Card className="border-0 shadow-lg rounded-3xl" data-testid="quick-actions">
          <CardHeader className="pb-4">
            <CardTitle className="text-lg font-semibold text-slate-800" style={{ fontFamily: 'Playfair Display, serif' }}>
              Azioni Rapide
            </CardTitle>
          </CardHeader>
          <CardContent className="space-y-3">
            <Button 
              onClick={() => navigate('/agenda')}
              className="w-full justify-start bg-blue-600 hover:bg-blue-700 h-14"
              data-testid="quick-new-appointment"
            >
              <Calendar className="w-5 h-5 mr-3" />
              <div className="text-left">
                <p className="font-medium">Nuovo Appuntamento</p>
                <p className="text-xs text-blue-200">Prenota un servizio</p>
              </div>
            </Button>

            <Button 
              onClick={() => navigate('/clienti')}
              variant="outline"
              className="w-full justify-start h-14 border-slate-200 hover:bg-slate-50"
              data-testid="quick-new-client"
            >
              <Users className="w-5 h-5 mr-3 text-purple-600" />
              <div className="text-left">
                <p className="font-medium text-slate-700">Nuovo Cliente</p>
                <p className="text-xs text-slate-400">Aggiungi anagrafica</p>
              </div>
            </Button>

            <Button 
              onClick={() => navigate('/cassa')}
              variant="outline"
              className="w-full justify-start h-14 border-slate-200 hover:bg-slate-50"
              data-testid="quick-register-payment"
            >
              <Euro className="w-5 h-5 mr-3 text-emerald-600" />
              <div className="text-left">
                <p className="font-medium text-slate-700">Registra Incasso</p>
                <p className="text-xs text-slate-400">Vai alla cassa</p>
              </div>
            </Button>

            <Button 
              onClick={generateScorteReport}
              variant="outline"
              className="w-full justify-start h-14 border-slate-200 hover:bg-slate-50"
              data-testid="quick-add-product"
            >
              <FileSpreadsheet className="w-5 h-5 mr-3 text-orange-500" />
              <div className="text-left">
                <p className="font-medium text-slate-700">Report Scorte</p>
                <p className="text-xs text-slate-400">CSV settimanale</p>
              </div>
            </Button>

            <Button 
              onClick={openSpesaRapida}
              variant="outline"
              className="w-full justify-start h-14 border-red-200 hover:bg-red-50"
              data-testid="quick-add-expense"
            >
              <Receipt className="w-5 h-5 mr-3 text-red-500" />
              <div className="text-left">
                <p className="font-medium text-slate-700">Carica Spesa</p>
                <p className="text-xs text-slate-400">Registra uscita</p>
              </div>
            </Button>

            <Button 
              onClick={openScaricoMagazzino}
              variant="outline"
              className="w-full justify-start h-14 border-amber-200 hover:bg-amber-50"
              data-testid="quick-scarico-magazzino"
            >
              <Package className="w-5 h-5 mr-3 text-amber-600" />
              <div className="text-left">
                <p className="font-medium text-slate-700">Scarica Prodotto</p>
                <p className="text-xs text-slate-400">Decrementa magazzino</p>
              </div>
            </Button>
          </CardContent>
        </Card>
      </div>

      {/* Dialog Obiettivo Mensile */}
      <Dialog open={showObiettivoDialog} onOpenChange={setShowObiettivoDialog}>
        <DialogContent className="max-w-md">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2">
              <Target className="w-5 h-5 text-amber-500" />
              Imposta Obiettivo Mensile
            </DialogTitle>
          </DialogHeader>
          <div className="space-y-4 pt-4">
            <div>
              <Label>Obiettivo di incasso (€)</Label>
              <Input 
                type="number"
                value={nuovoObiettivo}
                onChange={(e) => setNuovoObiettivo(e.target.value)}
                placeholder={obiettivoMensile.toString() || "Es: 5000"}
                className="mt-1"
              />
            </div>
            <div>
              <Label>PIN di sicurezza (opzionale)</Label>
              <Input 
                type="password"
                value={nuovoPin}
                onChange={(e) => setNuovoPin(e.target.value)}
                placeholder="4-6 cifre"
                maxLength={6}
                className="mt-1"
              />
              <p className="text-xs text-slate-500 mt-1">
                Se imposti un PIN, dovrai inserirlo per vedere l'obiettivo
              </p>
            </div>
            <div className="flex gap-2 pt-4">
              <Button variant="outline" onClick={() => setShowObiettivoDialog(false)} className="flex-1">
                Annulla
              </Button>
              <Button onClick={saveObiettivo} className="flex-1 bg-amber-500 hover:bg-amber-600">
                Salva
              </Button>
            </div>
          </div>
        </DialogContent>
      </Dialog>

      {/* Dialog Compleanni */}
      <Dialog open={showCompleanniDialog} onOpenChange={setShowCompleanniDialog}>
        <DialogContent className="max-w-lg max-h-[80vh] overflow-y-auto">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2">
              <Cake className="w-5 h-5 text-pink-500" />
              Tutti i Compleanni
            </DialogTitle>
          </DialogHeader>
          <div className="space-y-3 pt-4">
            {compleanni.filter(c => c.giorniMancanti >= 0).slice(0, 30).map(cliente => (
              <div 
                key={cliente.id}
                className={`flex items-center gap-3 p-3 rounded-xl ${
                  cliente.giorniMancanti === 0 
                    ? "bg-pink-50 border border-pink-200" 
                    : "bg-slate-50"
                }`}
              >
                <div className={`w-10 h-10 rounded-full flex items-center justify-center text-white font-bold ${
                  cliente.giorniMancanti === 0 ? "bg-pink-500" : 
                  cliente.giorniMancanti <= 7 ? "bg-rose-400" : "bg-slate-400"
                }`}>
                  {cliente.giorniMancanti === 0 ? "🎂" : cliente.giorniMancanti}
                </div>
                <div className="flex-1">
                  <p className="font-medium text-slate-800">
                    {cliente.nome} {cliente.cognome}
                  </p>
                  <p className="text-xs text-slate-500">
                    {format(cliente.prossimoCompleanno, "d MMMM", { locale: it })} - {cliente.eta} anni
                  </p>
                </div>
                {cliente.telefono && (
                  <Button 
                    variant="ghost" 
                    size="sm"
                    onClick={() => {
                      window.open(`https://wa.me/${cliente.telefono.replace(/\s/g, "")}?text=Tanti%20auguri%20di%20buon%20compleanno!%20🎂`, "_blank");
                    }}
                  >
                    <MessageCircle className="w-4 h-4 text-green-600" />
                  </Button>
                )}
              </div>
            ))}
          </div>
        </DialogContent>
      </Dialog>

      {/* Dialog Lista Clienti del Mese per Genere */}
      <Dialog open={clientiMeseDialog.open} onOpenChange={(open) => setClientiMeseDialog({ open, genere: clientiMeseDialog.genere })}>
        <DialogContent className="max-w-2xl max-h-[80vh] overflow-y-auto" data-testid="dialog-clienti-mese-genere">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2">
              <User className={`w-5 h-5 ${clientiMeseDialog.genere === 'M' ? 'text-sky-500' : 'text-pink-500'}`} />
              Clienti {clientiMeseDialog.genere === 'M' ? 'UOMO' : 'DONNA'} del mese ({clientiMesePerGenere.mese || ''})
            </DialogTitle>
          </DialogHeader>
          <div className="space-y-2 pt-3">
            {(() => {
              const lista = clientiMeseDialog.genere === 'M' ? (clientiMesePerGenere.lista_uomo || []) : (clientiMesePerGenere.lista_donna || []);
              if (lista.length === 0) {
                return <p className="text-center text-slate-400 py-6">Nessun cliente in questo mese</p>;
              }
              return lista.map((c, idx) => (
                <button
                  key={c.id}
                  onClick={() => { setClientiMeseDialog({ open: false, genere: null }); navigate(`/clienti/${c.id}`); }}
                  className="w-full flex items-center gap-3 p-3 rounded-xl bg-slate-50 hover:bg-slate-100 border border-slate-200 hover:border-slate-300 transition-all text-left"
                  data-testid={`cliente-mese-item-${idx}`}
                >
                  <div className={`w-10 h-10 rounded-full flex items-center justify-center text-white font-bold shrink-0 ${
                    clientiMeseDialog.genere === 'M' ? 'bg-sky-500' : 'bg-pink-500'
                  }`}>
                    {(c.nome?.[0] || '?').toUpperCase()}{(c.cognome?.[0] || '').toUpperCase()}
                  </div>
                  <div className="flex-1 min-w-0">
                    <p className="font-bold text-slate-800 truncate">
                      {c.nome} {c.cognome}
                    </p>
                    <p className="text-xs text-slate-500 truncate">
                      {c.num_visite} visit{c.num_visite === 1 ? 'a' : 'e'} questo mese
                      {c.ultima_visita && ` • Ultima: ${c.ultima_visita}`}
                      {c.incasso_mese > 0 && ` • €${c.incasso_mese.toFixed(2)}`}
                    </p>
                    {c.telefono && (
                      <p className="text-xs text-slate-400">📞 {c.telefono}</p>
                    )}
                  </div>
                  {c.telefono && (
                    <a
                      href={`https://wa.me/${c.telefono.replace(/\s/g, "").replace(/[^0-9+]/g, "")}`}
                      target="_blank"
                      rel="noreferrer"
                      onClick={(e) => e.stopPropagation()}
                      className="shrink-0 p-2 rounded-lg hover:bg-green-50"
                      title="WhatsApp"
                    >
                      <MessageCircle className="w-4 h-4 text-green-600" />
                    </a>
                  )}
                  <ChevronRight className="w-4 h-4 text-slate-400 shrink-0" />
                </button>
              ));
            })()}
          </div>
        </DialogContent>
      </Dialog>

      {/* Dialog Servizi Scaduti */}
      <Dialog open={showServiziScadutiDialog} onOpenChange={setShowServiziScadutiDialog}>
        <DialogContent className="max-w-2xl max-h-[80vh] overflow-y-auto" data-testid="dialog-servizi-scaduti">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2">
              <Bell className="w-5 h-5 text-rose-500" />
              Servizi in ritardo &mdash; appuntamenti prossimi 7 giorni
            </DialogTitle>
          </DialogHeader>
          <div className="space-y-2 pt-3">
            {serviziScaduti.alerts.length === 0 && (
              <div className="text-center py-6 space-y-3" data-testid="servizi-scaduti-empty">
                <div className="w-16 h-16 rounded-full bg-emerald-100 flex items-center justify-center mx-auto">
                  <CheckCircle2 className="w-8 h-8 text-emerald-600" />
                </div>
                <p className="text-emerald-700 font-semibold">Nessun servizio in ritardo</p>
                <p className="text-sm text-slate-500 px-4">
                  Per attivare le notifiche di richiamo, vai in <span className="font-semibold">Servizi</span> e imposta il campo <span className="font-semibold">"Richiamo (giorni)"</span> per ogni servizio (es. Colore = 40gg, Trattamento = 30gg, Meches = 60gg).
                </p>
                <Button
                  onClick={() => { setShowServiziScadutiDialog(false); navigate('/servizi'); }}
                  className="mt-3 bg-emerald-500 hover:bg-emerald-600 text-white"
                  data-testid="btn-vai-servizi"
                >
                  <Scissors className="w-4 h-4 mr-2" /> Vai a configurare i timer
                </Button>
              </div>
            )}
            {serviziScaduti.alerts.map((a, idx) => (
              <button
                key={`${a.cliente_id}-${a.servizio}-${idx}`}
                onClick={() => navigate(`/agenda?data=${a.appuntamento_data}`)}
                className={`w-full flex items-start gap-3 p-3 rounded-xl border-2 text-left transition-all hover:shadow-md ${
                  a.priorita === 'alta'
                    ? 'bg-rose-50 border-rose-200 hover:border-rose-400'
                    : 'bg-amber-50 border-amber-200 hover:border-amber-400'
                }`}
                data-testid={`servizio-scaduto-item-${idx}`}
              >
                <div className={`w-10 h-10 rounded-xl flex items-center justify-center shrink-0 ${
                  a.priorita === 'alta' ? 'bg-rose-500' : 'bg-amber-500'
                }`}>
                  <Scissors className="w-5 h-5 text-white" />
                </div>
                <div className="flex-1 min-w-0">
                  <p className="font-bold text-slate-800 truncate">
                    {a.cliente_nome.toUpperCase()}
                  </p>
                  <p className="text-sm text-slate-700">
                    NON ESEGUE <span className="font-bold uppercase">{a.servizio}</span> da{' '}
                    <span className="font-bold text-rose-700">{a.giorni_assenza} giorni</span>
                  </p>
                  <p className="text-xs text-slate-500 mt-0.5">
                    Timer cadenza: <span className="font-semibold">{a.giorni_richiamo}gg</span>
                    {' '}&middot; Ritardo: <span className="font-semibold text-rose-600">+{a.ritardo_giorni}gg</span>
                    {' '}&middot; Ultima volta: {a.ultima_esecuzione}
                  </p>
                  <p className="text-xs text-slate-600 mt-1 flex items-center gap-1">
                    <Calendar className="w-3 h-3" />
                    Appuntamento {a.appuntamento_data} alle {a.appuntamento_ora}
                  </p>
                </div>
                <ChevronRight className="w-5 h-5 text-slate-400 shrink-0 mt-1" />
              </button>
            ))}
          </div>
        </DialogContent>
      </Dialog>


      {/* Dialog Scorte Report */}
      <Dialog open={showScorteDialog} onOpenChange={setShowScorteDialog}>
        <DialogContent className="max-w-3xl max-h-[80vh] overflow-y-auto">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2">
              <FileSpreadsheet className="w-5 h-5 text-orange-500" />
              Report Scorte Settimanale
            </DialogTitle>
          </DialogHeader>
          
          <div className="space-y-6 pt-4">
            {/* RIVENDITA */}
            <div className="border rounded-xl overflow-hidden">
              <div className="bg-purple-50 p-4 flex items-center justify-between">
                <div>
                  <h3 className="font-semibold text-purple-800">RIVENDITA</h3>
                  <p className="text-xs text-purple-600">{scorteReport.rivendita.length} prodotti</p>
                </div>
                <div className="flex gap-2">
                  <Button 
                    size="sm" 
                    variant="outline"
                    onClick={() => downloadCSV("rivendita")}
                  >
                    <Download className="w-4 h-4 mr-1" /> CSV
                  </Button>
                  <Button 
                    size="sm" 
                    className="bg-green-600 hover:bg-green-700"
                    onClick={() => sendCSVWhatsApp("rivendita")}
                  >
                    <MessageCircle className="w-4 h-4 mr-1" /> WhatsApp
                  </Button>
                </div>
              </div>
              <div className="p-4 max-h-[200px] overflow-y-auto">
                <table className="w-full text-sm">
                  <thead className="text-slate-500 border-b">
                    <tr>
                      <th className="text-left py-2">Prodotto</th>
                      <th className="text-center py-2">Qta</th>
                      <th className="text-center py-2">Min</th>
                      <th className="text-right py-2">Stato</th>
                    </tr>
                  </thead>
                  <tbody>
                    {scorteReport.rivendita.map(p => (
                      <tr key={p.id} className="border-b last:border-0">
                        <td className="py-2 font-medium">{p.nome}</td>
                        <td className="py-2 text-center">{p.quantita || 0}</td>
                        <td className="py-2 text-center text-slate-400">{p.scorta_minima || 0}</td>
                        <td className="py-2 text-right">
                          {(p.quantita || 0) < (p.scorta_minima || 0) ? (
                            <span className="text-red-600 text-xs font-medium">⚠️ Ordinare</span>
                          ) : (
                            <span className="text-green-600 text-xs">✓ OK</span>
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>

            {/* TECNICO */}
            <div className="border rounded-xl overflow-hidden">
              <div className="bg-blue-50 p-4 flex items-center justify-between">
                <div>
                  <h3 className="font-semibold text-blue-800">TECNICO (Hair Care)</h3>
                  <p className="text-xs text-blue-600">{scorteReport.tecnico.length} prodotti</p>
                </div>
                <div className="flex gap-2">
                  <Button 
                    size="sm" 
                    variant="outline"
                    onClick={() => downloadCSV("tecnico")}
                  >
                    <Download className="w-4 h-4 mr-1" /> CSV
                  </Button>
                  <Button 
                    size="sm" 
                    className="bg-green-600 hover:bg-green-700"
                    onClick={() => sendCSVWhatsApp("tecnico")}
                  >
                    <MessageCircle className="w-4 h-4 mr-1" /> WhatsApp
                  </Button>
                </div>
              </div>
              <div className="p-4 max-h-[200px] overflow-y-auto">
                <table className="w-full text-sm">
                  <thead className="text-slate-500 border-b">
                    <tr>
                      <th className="text-left py-2">Prodotto</th>
                      <th className="text-center py-2">Qta</th>
                      <th className="text-center py-2">Min</th>
                      <th className="text-right py-2">Stato</th>
                    </tr>
                  </thead>
                  <tbody>
                    {scorteReport.tecnico.map(p => (
                      <tr key={p.id} className="border-b last:border-0">
                        <td className="py-2 font-medium">{p.nome}</td>
                        <td className="py-2 text-center">{p.quantita || 0}</td>
                        <td className="py-2 text-center text-slate-400">{p.scorta_minima || 0}</td>
                        <td className="py-2 text-right">
                          {(p.quantita || 0) < (p.scorta_minima || 0) ? (
                            <span className="text-red-600 text-xs font-medium">⚠️ Ordinare</span>
                          ) : (
                            <span className="text-green-600 text-xs">✓ OK</span>
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </DialogContent>
      </Dialog>

      {/* DIALOG REPORT MENSILE */}
      <Dialog open={showReportDialog} onOpenChange={setShowReportDialog}>
        <DialogContent className="max-w-2xl max-h-[85vh] overflow-y-auto">
          <DialogHeader>
            <DialogTitle className="text-xl font-bold flex items-center gap-2">
              <FileSpreadsheet className="w-6 h-6 text-blue-600" />
              Report Mensile - {reportMensile?.mese || 'Caricamento...'}
            </DialogTitle>
          </DialogHeader>
          
          {reportMensile && (
            <div className="space-y-6 mt-4">
              {/* Riepilogo Giorni */}
              <div className="bg-slate-50 rounded-xl p-4">
                <h3 className="font-semibold text-slate-700 mb-3 flex items-center gap-2">
                  <Calendar className="w-4 h-4" />
                  Giorni del Mese
                </h3>
                <div className="grid grid-cols-2 md:grid-cols-4 gap-3 text-center">
                  <div className="bg-white p-3 rounded-lg shadow-sm">
                    <p className="text-2xl font-bold text-slate-800">{reportMensile.totale_giorni_mese}</p>
                    <p className="text-xs text-slate-500">Totale giorni</p>
                  </div>
                  <div className="bg-green-50 p-3 rounded-lg shadow-sm">
                    <p className="text-2xl font-bold text-green-600">{reportMensile.giorni_lavorativi}</p>
                    <p className="text-xs text-green-700">Giorni lavorativi</p>
                  </div>
                  <div className="bg-slate-100 p-3 rounded-lg shadow-sm">
                    <p className="text-2xl font-bold text-slate-600">{reportMensile.giorni_chiusura_settimanale}</p>
                    <p className="text-xs text-slate-500">Chiusure settimanali</p>
                  </div>
                  <div className="bg-orange-50 p-3 rounded-lg shadow-sm">
                    <p className="text-2xl font-bold text-orange-600">{reportMensile.giorni_chiusura_straordinaria}</p>
                    <p className="text-xs text-orange-700">Chiusure extra</p>
                  </div>
                </div>
                
                {/* Dettaglio giorni per settimana */}
                <div className="mt-3 grid grid-cols-7 gap-1 text-center text-xs">
                  {Object.entries(reportMensile.dettaglio_giorni_settimana || {}).map(([giorno, count]) => (
                    <div key={giorno} className="bg-white p-2 rounded">
                      <p className="font-medium text-slate-600">{giorno.substring(0, 3)}</p>
                      <p className="text-slate-800">{count}</p>
                    </div>
                  ))}
                </div>
              </div>
              
              {/* Obiettivi */}
              <div className="bg-amber-50 rounded-xl p-4">
                <h3 className="font-semibold text-amber-700 mb-3 flex items-center gap-2">
                  <Target className="w-4 h-4" />
                  Obiettivi
                </h3>
                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <p className="text-sm text-amber-600">Obiettivo Mensile</p>
                    <p className="text-2xl font-bold text-amber-800">€{reportMensile.obiettivo_mensile?.toLocaleString() || 0}</p>
                  </div>
                  <div>
                    <p className="text-sm text-amber-600">Obiettivo Giornaliero</p>
                    <p className="text-2xl font-bold text-amber-800">€{reportMensile.obiettivo_giornaliero?.toFixed(0) || 0}</p>
                  </div>
                </div>
                <p className="text-xs text-amber-600 mt-2 bg-amber-100 p-2 rounded">
                  📊 {reportMensile.nota_calcolo}
                </p>
              </div>
              
              {/* Incassi */}
              <div className="bg-emerald-50 rounded-xl p-4">
                <h3 className="font-semibold text-emerald-700 mb-3 flex items-center gap-2">
                  <Euro className="w-4 h-4" />
                  Incassi
                </h3>
                <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
                  <div className="bg-white p-3 rounded-lg shadow-sm">
                    <p className="text-xs text-slate-500">Incasso Reale</p>
                    <p className="text-xl font-bold text-emerald-600">€{reportMensile.incasso_reale?.toLocaleString()}</p>
                  </div>
                  <div className="bg-white p-3 rounded-lg shadow-sm">
                    <p className="text-xs text-slate-500">Contanti</p>
                    <p className="text-lg font-semibold text-slate-700">€{reportMensile.incasso_contanti?.toLocaleString()}</p>
                  </div>
                  <div className="bg-white p-3 rounded-lg shadow-sm">
                    <p className="text-xs text-slate-500">Carta/POS</p>
                    <p className="text-lg font-semibold text-slate-700">€{reportMensile.incasso_carta?.toLocaleString()}</p>
                  </div>
                  <div className="bg-white p-3 rounded-lg shadow-sm">
                    <p className="text-xs text-slate-500">Ricariche Card</p>
                    <p className="text-lg font-semibold text-blue-600">€{reportMensile.ricariche_card?.toLocaleString()}</p>
                  </div>
                  <div className="bg-purple-50 p-3 rounded-lg shadow-sm">
                    <p className="text-xs text-purple-500">Uso Card Prepagata</p>
                    <p className="text-lg font-semibold text-purple-600">€{reportMensile.uso_card_prepagata?.toLocaleString()}</p>
                    <p className="text-[10px] text-purple-400">(non conteggiato)</p>
                  </div>
                </div>
                
                {/* Progress bar obiettivo */}
                <div className="mt-4">
                  <div className="flex justify-between text-sm mb-1">
                    <span className="text-emerald-600">Progresso obiettivo</span>
                    <span className="font-bold text-emerald-700">{reportMensile.percentuale_obiettivo?.toFixed(1)}%</span>
                  </div>
                  <div className="h-3 bg-emerald-200 rounded-full overflow-hidden">
                    <div 
                      className={`h-full rounded-full ${reportMensile.percentuale_obiettivo >= 100 ? 'bg-emerald-500' : 'bg-emerald-400'}`}
                      style={{ width: `${Math.min(100, reportMensile.percentuale_obiettivo || 0)}%` }}
                    />
                  </div>
                  {reportMensile.mancante_obiettivo > 0 && (
                    <p className="text-sm text-orange-600 mt-2">
                      ⚠️ Mancano €{reportMensile.mancante_obiettivo?.toLocaleString()} all'obiettivo
                    </p>
                  )}
                </div>
              </div>
              
              {/* Statistiche */}
              <div className="bg-blue-50 rounded-xl p-4">
                <h3 className="font-semibold text-blue-700 mb-3 flex items-center gap-2">
                  <TrendingUp className="w-4 h-4" />
                  Statistiche
                </h3>
                <div className="grid grid-cols-2 md:grid-cols-4 gap-3 text-center">
                  <div className="bg-white p-3 rounded-lg shadow-sm">
                    <p className="text-xs text-slate-500">Media giornaliera</p>
                    <p className="text-lg font-bold text-blue-600">€{reportMensile.media_giornaliera?.toFixed(0)}</p>
                  </div>
                  <div className="bg-white p-3 rounded-lg shadow-sm">
                    <p className="text-xs text-slate-500">Proiezione fine mese</p>
                    <p className="text-lg font-bold text-blue-600">€{reportMensile.proiezione_fine_mese?.toLocaleString()}</p>
                  </div>
                  <div className="bg-white p-3 rounded-lg shadow-sm">
                    <p className="text-xs text-slate-500">Appuntamenti</p>
                    <p className="text-lg font-bold text-slate-700">{reportMensile.totale_appuntamenti}</p>
                  </div>
                  <div className="bg-white p-3 rounded-lg shadow-sm">
                    <p className="text-xs text-slate-500">Pagati</p>
                    <p className="text-lg font-bold text-green-600">{reportMensile.appuntamenti_pagati}</p>
                  </div>
                </div>
              </div>
              
              {/* Chiusure straordinarie */}
              {reportMensile.chiusure_straordinarie && reportMensile.chiusure_straordinarie.length > 0 && (
                <div className="bg-orange-50 rounded-xl p-4">
                  <h3 className="font-semibold text-orange-700 mb-3 flex items-center gap-2">
                    <AlertTriangle className="w-4 h-4" />
                    Chiusure Straordinarie
                  </h3>
                  <div className="space-y-2">
                    {reportMensile.chiusure_straordinarie.map((c, idx) => (
                      <div key={c.data || `${c.data_inizio}-${c.data_fine}-${idx}`} className="bg-white p-2 rounded-lg text-sm flex justify-between">
                        <span className="font-medium">{c.motivo}</span>
                        <span className="text-slate-500">
                          {c.data || `${c.data_inizio} - ${c.data_fine}`}
                        </span>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          )}
        </DialogContent>
      </Dialog>

      {/* Dialog Spesa Rapida */}
      <Dialog open={spesaRapidaOpen} onOpenChange={setSpesaRapidaOpen}>
        <DialogContent className="sm:max-w-md">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2">
              <Receipt className="w-5 h-5 text-red-500" />
              Registra Spesa
            </DialogTitle>
          </DialogHeader>
          
          <div className="space-y-4 py-4">
            <div className="space-y-2">
              <Label>Macrocategoria *</Label>
              <Select 
                value={spesaForm.macrocategoria_id} 
                onValueChange={(v) => setSpesaForm({...spesaForm, macrocategoria_id: v, categoria_id: ""})}
              >
                <SelectTrigger>
                  <SelectValue placeholder="Seleziona..." />
                </SelectTrigger>
                <SelectContent>
                  {macrocategorie.map(m => (
                    <SelectItem key={m.id} value={m.id}>{m.nome}</SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div>

            <div className="space-y-2">
              <Label>Categoria</Label>
              <Select 
                value={spesaForm.categoria_id} 
                onValueChange={(v) => setSpesaForm({...spesaForm, categoria_id: v})}
                disabled={!spesaForm.macrocategoria_id}
              >
                <SelectTrigger>
                  <SelectValue placeholder="Seleziona..." />
                </SelectTrigger>
                <SelectContent>
                  {categorie
                    .filter(c => c.macrocategoria_id === spesaForm.macrocategoria_id)
                    .map(c => (
                      <SelectItem key={c.id} value={c.id}>{c.nome}</SelectItem>
                    ))}
                </SelectContent>
              </Select>
            </div>

            <div className="grid grid-cols-2 gap-4">
              <div className="space-y-2">
                <Label>Importo (€) *</Label>
                <Input
                  type="number"
                  step="0.01"
                  value={spesaForm.importo}
                  onChange={(e) => setSpesaForm({...spesaForm, importo: e.target.value})}
                  placeholder="0.00"
                />
              </div>
              <div className="space-y-2">
                <Label>Data</Label>
                <Input
                  type="date"
                  value={spesaForm.data_spesa}
                  onChange={(e) => setSpesaForm({...spesaForm, data_spesa: e.target.value})}
                />
              </div>
            </div>

            <div className="space-y-2">
              <Label>Descrizione</Label>
              <Input
                value={spesaForm.descrizione}
                onChange={(e) => setSpesaForm({...spesaForm, descrizione: e.target.value})}
                placeholder="Es: Fattura L'Oréal marzo"
              />
            </div>
          </div>

          <div className="flex gap-2 justify-end">
            <Button variant="outline" onClick={() => setSpesaRapidaOpen(false)}>
              Annulla
            </Button>
            <Button onClick={handleSalvaSpesaRapida} className="bg-red-600 hover:bg-red-700">
              Registra Spesa
            </Button>
          </div>
        </DialogContent>
      </Dialog>

      {/* Dialog Scarico Magazzino */}
      <Dialog open={scaricoMagazzinoOpen} onOpenChange={(open) => { setScaricoMagazzinoOpen(open); if (open) setScaricoRicerca(""); }}>
        <DialogContent className="sm:max-w-md">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2">
              <Package className="w-5 h-5 text-amber-600" />
              Scarica Prodotto
            </DialogTitle>
          </DialogHeader>
          
          <div className="space-y-4 py-4">
            <div className="space-y-2">
              <Label>Prodotto * <span className="text-[10px] text-slate-500">({prodottiMagazzino.length} totali)</span></Label>
              {/* Ricerca rapida — filtra per nome/marca in real-time */}
              <Input
                type="text"
                placeholder="🔍 Cerca per nome o marca..."
                value={scaricoRicerca}
                onChange={(e) => setScaricoRicerca(e.target.value)}
                autoFocus
                className="mb-2"
                data-testid="scarico-search"
              />
              {/* Lista filtrata (max 8 risultati per performance) */}
              {(() => {
                const q = scaricoRicerca.toLowerCase().trim();
                const filtrati = q
                  ? prodottiMagazzino.filter(p =>
                      (p.nome || '').toLowerCase().includes(q) ||
                      (p.marca || '').toLowerCase().includes(q)
                    ).slice(0, 8)
                  : prodottiMagazzino.slice(0, 8);
                return (
                  <div className="max-h-56 overflow-y-auto border rounded-lg bg-white">
                    {filtrati.length === 0 && (
                      <p className="text-xs text-slate-400 text-center py-4">Nessun prodotto trovato</p>
                    )}
                    {filtrati.map(p => (
                      <button
                        key={p.id}
                        type="button"
                        onClick={() => setScaricoForm({ ...scaricoForm, prodotto_id: p.id })}
                        className={`w-full text-left px-3 py-2 border-b last:border-b-0 hover:bg-amber-50 transition ${
                          scaricoForm.prodotto_id === p.id ? 'bg-amber-100 border-l-4 border-l-amber-500' : ''
                        }`}
                        data-testid={`scarico-prod-${p.id}`}
                      >
                        <div className="flex items-center justify-between gap-2">
                          <div className="min-w-0">
                            <p className="text-sm font-semibold text-slate-800 truncate">{p.nome}</p>
                            {p.marca && <p className="text-[10px] text-slate-500 truncate">{p.marca}</p>}
                          </div>
                          <span className={`text-xs font-bold shrink-0 ${(p.quantita || 0) <= (p.soglia_minima || 3) ? 'text-red-600' : 'text-emerald-600'}`}>
                            {p.quantita || 0} pz
                          </span>
                        </div>
                      </button>
                    ))}
                    {!q && prodottiMagazzino.length > 8 && (
                      <p className="text-[10px] text-slate-400 text-center py-2 border-t">
                        Digita per cercare tra tutti i {prodottiMagazzino.length} prodotti
                      </p>
                    )}
                  </div>
                );
              })()}
            </div>

            <div className="grid grid-cols-2 gap-4">
              <div className="space-y-2">
                <Label>Quantità *</Label>
                <Input
                  type="number"
                  min="1"
                  value={scaricoForm.quantita}
                  onChange={(e) => setScaricoForm({...scaricoForm, quantita: e.target.value})}
                />
              </div>
              <div className="space-y-2">
                <Label>Motivo</Label>
                <Select 
                  value={scaricoForm.motivo} 
                  onValueChange={(v) => setScaricoForm({...scaricoForm, motivo: v})}
                >
                  <SelectTrigger>
                    <SelectValue />
                  </SelectTrigger>
                  <SelectContent>
                    <SelectItem value="utilizzo">Utilizzo</SelectItem>
                    <SelectItem value="scadenza">Scadenza</SelectItem>
                    <SelectItem value="danneggiato">Danneggiato</SelectItem>
                    <SelectItem value="altro">Altro</SelectItem>
                  </SelectContent>
                </Select>
              </div>
            </div>

            <div className="space-y-2">
              <Label>Note</Label>
              <Input
                value={scaricoForm.note}
                onChange={(e) => setScaricoForm({...scaricoForm, note: e.target.value})}
                placeholder="Note opzionali..."
              />
            </div>
          </div>

          <div className="flex gap-2 justify-end">
            <Button variant="outline" onClick={() => setScaricoMagazzinoOpen(false)}>
              Annulla
            </Button>
            <Button onClick={handleScaricoMagazzino} className="bg-amber-600 hover:bg-amber-700">
              Scarica Prodotto
            </Button>
          </div>
        </DialogContent>
      </Dialog>

      {/* Dialog Scadenze Pagamenti */}
      <Dialog open={showScadenzeDialog} onOpenChange={setShowScadenzeDialog}>
        <DialogContent className="sm:max-w-3xl max-h-[90vh] overflow-y-auto" data-testid="dialog-scadenze-pagamenti">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2">
              <Wallet className="w-5 h-5 text-red-600" />
              Scadenze Pagamenti
            </DialogTitle>
          </DialogHeader>
          {scadenze && (
            <div className="space-y-4">
              {/* KPI */}
              <div className="grid grid-cols-2 gap-3">
                {scadenze.num_scadute > 0 && (
                  <div className="bg-red-50 border border-red-200 rounded-2xl p-4">
                    <p className="text-xs text-red-700 font-semibold uppercase">SCADUTI</p>
                    <p className="text-3xl font-bold text-red-700 mt-1">€{scadenze.importo_scaduto.toFixed(2)}</p>
                    <p className="text-xs text-red-600 mt-1">{scadenze.num_scadute} pagamenti</p>
                  </div>
                )}
                {scadenze.num_in_scadenza > 0 && (
                  <div className="bg-amber-50 border border-amber-200 rounded-2xl p-4">
                    <p className="text-xs text-amber-700 font-semibold uppercase">IN SCADENZA (7gg)</p>
                    <p className="text-3xl font-bold text-amber-700 mt-1">€{scadenze.importo_in_scadenza.toFixed(2)}</p>
                    <p className="text-xs text-amber-600 mt-1">{scadenze.num_in_scadenza} pagamenti</p>
                  </div>
                )}
              </div>

              {/* Lista scaduti */}
              {scadenze.scadute.length > 0 && (
                <div>
                  <p className="text-sm font-bold text-red-700 mb-2 uppercase">⚠ Già scaduti</p>
                  <div className="space-y-2">
                    {scadenze.scadute.map(s => (
                      <div key={`${s.tipo}-${s.id}`} className="flex items-center justify-between p-3 bg-red-50 border border-red-200 rounded-lg">
                        <div className="flex-1 min-w-0">
                          <div className="flex items-center gap-2">
                            <span className={`inline-block text-[10px] px-2 py-0.5 rounded-full font-semibold ${s.tipo === "fornitore" ? 'bg-blue-100 text-blue-700' : 'bg-purple-100 text-purple-700'}`}>
                              {s.tipo === "fornitore" ? "FORNITORE" : "EXTRA"}
                            </span>
                            <p className="font-medium text-slate-800 truncate">{s.descrizione}</p>
                          </div>
                          <p className="text-xs text-red-600 mt-1">
                            Scaduto da {-s.giorni_rimanenti} giorni • {s.macrocategoria_nome}
                          </p>
                        </div>
                        <p className="font-bold text-red-700 ml-2">€{s.importo.toFixed(2)}</p>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {/* Lista in scadenza */}
              {scadenze.in_scadenza.length > 0 && (
                <div>
                  <p className="text-sm font-bold text-amber-700 mb-2 uppercase">Prossime scadenze (7 giorni)</p>
                  <div className="space-y-2">
                    {scadenze.in_scadenza.map(s => (
                      <div key={`${s.tipo}-${s.id}`} className="flex items-center justify-between p-3 bg-amber-50 border border-amber-200 rounded-lg">
                        <div className="flex-1 min-w-0">
                          <div className="flex items-center gap-2">
                            <span className={`inline-block text-[10px] px-2 py-0.5 rounded-full font-semibold ${s.tipo === "fornitore" ? 'bg-blue-100 text-blue-700' : 'bg-purple-100 text-purple-700'}`}>
                              {s.tipo === "fornitore" ? "FORNITORE" : "EXTRA"}
                            </span>
                            <p className="font-medium text-slate-800 truncate">{s.descrizione}</p>
                          </div>
                          <p className="text-xs text-amber-600 mt-1">
                            Tra {s.giorni_rimanenti} {s.giorni_rimanenti === 1 ? 'giorno' : 'giorni'} • {s.macrocategoria_nome}
                          </p>
                        </div>
                        <p className="font-bold text-amber-700 ml-2">€{s.importo.toFixed(2)}</p>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              <div className="flex justify-end pt-2 border-t">
                <Button
                  onClick={() => { setShowScadenzeDialog(false); navigate('/analisi'); }}
                  className="bg-blue-600 hover:bg-blue-700 text-white"
                  data-testid="vai-bilancio-da-scadenze"
                >
                  Apri Bilancio per gestire
                </Button>
              </div>
            </div>
          )}
        </DialogContent>
      </Dialog>

      {/* Dialog Riepilogo Card Attive (PIN protetto) */}
      <Dialog open={showCardsDialog} onOpenChange={(open) => {
        setShowCardsDialog(open);
        if (!open) {
          setCardsRiepilogo(null);
          setCardsPinInput("");
          setCardsPinError("");
        }
      }}>
        <DialogContent className="sm:max-w-2xl max-h-[90vh] overflow-y-auto" data-testid="cards-riepilogo-dialog">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2">
              <Wallet className="w-5 h-5 text-emerald-600" />
              Riepilogo Card Attive
            </DialogTitle>
          </DialogHeader>

          {/* Sblocco PIN */}
          {cardsPinAttivo && !cardsRiepilogo && (
            <div className="space-y-3 py-4">
              <Label htmlFor="cards-pin">Inserisci il PIN per visualizzare il riepilogo</Label>
              <Input
                id="cards-pin"
                type="password"
                inputMode="numeric"
                maxLength={6}
                value={cardsPinInput}
                onChange={(e) => setCardsPinInput(e.target.value.replace(/\D/g, ""))}
                onKeyDown={(e) => { if (e.key === "Enter") loadCardsRiepilogo(cardsPinInput); }}
                placeholder="••••"
                autoFocus
                className="text-center text-2xl tracking-widest"
                data-testid="cards-pin-input"
              />
              {cardsPinError && <p className="text-sm text-red-500">{cardsPinError}</p>}
              <Button
                onClick={() => loadCardsRiepilogo(cardsPinInput)}
                disabled={!cardsPinInput || cardsLoading}
                className="w-full bg-emerald-600 hover:bg-emerald-700 text-white"
                data-testid="cards-pin-submit"
              >
                {cardsLoading ? "Verifica..." : "Sblocca"}
              </Button>
            </div>
          )}

          {/* Riepilogo + lista */}
          {cardsRiepilogo && (
            <div className="space-y-4 py-2">
              {/* KPI riassuntivi */}
              <div className="grid grid-cols-2 gap-3">
                <div className="bg-gradient-to-br from-emerald-50 to-teal-50 border border-emerald-200 rounded-2xl p-4">
                  <p className="text-xs text-emerald-700 font-semibold uppercase tracking-wide">Card Attive</p>
                  <p className="text-3xl font-bold text-emerald-700 mt-1" data-testid="cards-totale-attive">
                    {cardsRiepilogo.riepilogo.totale_card_attive}
                  </p>
                </div>
                <div className="bg-gradient-to-br from-blue-50 to-cyan-50 border border-blue-200 rounded-2xl p-4">
                  <p className="text-xs text-blue-700 font-semibold uppercase tracking-wide">Saldo Residuo</p>
                  <p className="text-3xl font-bold text-blue-700 mt-1" data-testid="cards-saldo-totale">
                    €{cardsRiepilogo.riepilogo.saldo_totale.toFixed(2)}
                  </p>
                </div>
                <div className="bg-slate-50 border border-slate-200 rounded-2xl p-4">
                  <p className="text-xs text-slate-500 font-semibold uppercase tracking-wide">Valore Caricato</p>
                  <p className="text-xl font-bold text-slate-700 mt-1">
                    €{cardsRiepilogo.riepilogo.valore_iniziale_totale.toFixed(2)}
                  </p>
                </div>
                <div className="bg-slate-50 border border-slate-200 rounded-2xl p-4">
                  <p className="text-xs text-slate-500 font-semibold uppercase tracking-wide">Già Utilizzato</p>
                  <p className="text-xl font-bold text-slate-700 mt-1">
                    €{cardsRiepilogo.riepilogo.valore_utilizzato_totale.toFixed(2)}
                  </p>
                </div>
              </div>

              {/* Lista card dettagliata */}
              {cardsRiepilogo.cards.length > 0 ? (
                <div className="border rounded-2xl overflow-hidden">
                  <div className="bg-slate-100 px-4 py-2 grid grid-cols-12 text-xs font-semibold text-slate-600">
                    <div className="col-span-6">Cliente</div>
                    <div className="col-span-3 text-right">Saldo</div>
                    <div className="col-span-3 text-right">Tipo</div>
                  </div>
                  <div className="max-h-96 overflow-y-auto divide-y">
                    {cardsRiepilogo.cards.map((card) => (
                      <div
                        key={card.id}
                        className="px-4 py-2 grid grid-cols-12 text-sm hover:bg-blue-50 transition"
                        data-testid={`card-item-${card.id}`}
                      >
                        <div className="col-span-6">
                          <p className="font-medium text-slate-700">{card.cliente_nome}</p>
                          {card.telefono && <p className="text-xs text-slate-400">{card.telefono}</p>}
                        </div>
                        <div className="col-span-3 text-right">
                          <span className={`font-bold ${card.saldo > 0 ? 'text-emerald-600' : 'text-slate-400'}`}>
                            €{card.saldo.toFixed(2)}
                          </span>
                          {card.valore_iniziale > 0 && (
                            <p className="text-[10px] text-slate-400">su €{card.valore_iniziale.toFixed(2)}</p>
                          )}
                        </div>
                        <div className="col-span-3 text-right text-xs text-slate-500">
                          {card.tipo || "—"}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              ) : (
                <p className="text-center text-slate-400 py-8">Nessuna card attiva</p>
              )}
            </div>
          )}
        </DialogContent>
      </Dialog>

      {/* Dialog Pianifica Obiettivo Mese (con soglie ERP per quel mese) */}
      <Dialog open={pianifDialogOpen} onOpenChange={setPianifDialogOpen}>
        <DialogContent className="!max-w-lg w-[95vw] max-h-[85vh] overflow-y-auto">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2">
              📅 Pianifica Mese
              <span className="text-sm font-normal text-slate-500">
                {format(new Date(pianifMese + '-01'), 'MMMM yyyy', { locale: it })}
              </span>
            </DialogTitle>
          </DialogHeader>
          <div className="space-y-4 pt-2">
            <p className="text-xs text-slate-500">
              Imposta obiettivo di fatturato e % soglie sui costi <strong>produttivi</strong> (tecnico, rivendita, utenze, monouso, abbonamenti). L'affitto NON entra nelle soglie % perché è un costo fisso indipendente dal fatturato.
            </p>

            {/* Selettore mese futuro */}
            <div>
              <Label className="text-xs font-semibold">Mese da pianificare</Label>
              <select
                value={pianifMese}
                onChange={(e) => setPianifMese(e.target.value)}
                className="w-full mt-1 px-3 py-2 border border-slate-300 rounded-md text-sm bg-white"
                data-testid="pianif-mese-select"
              >
                {(() => {
                  const opts = [];
                  const now = new Date();
                  for (let i = 0; i <= 18; i++) {
                    const d = new Date(now.getFullYear(), now.getMonth() + i, 1);
                    const ym = format(d, 'yyyy-MM');
                    opts.push(
                      <option key={ym} value={ym}>
                        {format(d, 'MMMM yyyy', { locale: it })}{obiettiviMensili[ym] ? ' ✓ pianificato' : ''}
                      </option>
                    );
                  }
                  return opts;
                })()}
              </select>
            </div>

            {/* Obiettivo Mese */}
            <div className="bg-gradient-to-r from-amber-50 to-orange-50 border border-amber-200 rounded-xl p-3">
              <Label className="text-xs font-semibold text-amber-800 uppercase tracking-wide">
                🎯 Obiettivo Fatturato Mese
              </Label>
              <div className="flex items-center gap-2 mt-2">
                <span className="text-sm text-slate-500">€</span>
                <Input
                  type="number"
                  min="0"
                  step="500"
                  value={pianifForm.obiettivo || 0}
                  onChange={(e) => setPianifForm({ ...pianifForm, obiettivo: parseFloat(e.target.value) || 0 })}
                  className="flex-1 text-right font-bold text-amber-900"
                  placeholder="Es: 15000"
                  data-testid="pianif-obiettivo"
                />
              </div>
            </div>

            {/* Soglie % per categoria */}
            <div className="border-t pt-3">
              <p className="text-xs font-semibold text-slate-600 uppercase tracking-wide mb-2">Soglie % per Categoria</p>
              {[
                { k: 'ordine_tecnico', label: '💇 Ordine Tecnico', color: 'purple' },
                { k: 'rivendita', label: '🛍️ Rivendita', color: 'teal' },
                { k: 'monouso', label: '🧻 Monouso', color: 'amber' },
                { k: 'utenze', label: '⚡ Utenze (luce, gas, internet)', color: 'blue' },
                { k: 'abbonamenti', label: '📋 Abbonamenti (software, canoni)', color: 'indigo' },
                { k: 'totale_spese', label: '📊 Totale Spese (globale)', color: 'red' }
              ].map(s => (
                <div key={s.k} className="flex items-center gap-3 py-1">
                  <label className="flex-1 text-sm text-slate-700">{s.label}</label>
                  <div className="relative">
                    <Input
                      type="number"
                      min="0"
                      max="100"
                      step="0.5"
                      value={pianifForm.soglie?.[s.k] ?? 0}
                      onChange={(e) => setPianifForm({
                        ...pianifForm,
                        soglie: { ...pianifForm.soglie, [s.k]: parseFloat(e.target.value) || 0 }
                      })}
                      className="w-20 h-8 pr-6 text-right text-sm"
                      data-testid={`pianif-soglia-${s.k}`}
                    />
                    <span className="absolute right-2 top-1/2 -translate-y-1/2 text-xs text-slate-400">%</span>
                  </div>
                </div>
              ))}
            </div>

            {/* Preview target */}
            {pianifForm.obiettivo > 0 && (
              <div className="bg-blue-50 rounded-xl p-3 text-xs text-blue-800">
                <strong>Preview:</strong> Con obiettivo €{pianifForm.obiettivo}, il budget Ordine Tecnico sarà €{((pianifForm.obiettivo * (pianifForm.soglie?.ordine_tecnico || 0)) / 100).toFixed(0)}, Rivendita €{((pianifForm.obiettivo * (pianifForm.soglie?.rivendita || 0)) / 100).toFixed(0)}, Utenze €{((pianifForm.obiettivo * (pianifForm.soglie?.utenze || 0)) / 100).toFixed(0)}.
              </div>
            )}

            <div className="flex gap-2 pt-3 border-t">
              {obiettiviMensili[pianifMese] && (
                <Button
                  variant="destructive"
                  size="sm"
                  onClick={async () => {
                    if (!window.confirm(`Rimuovere pianificazione per ${format(new Date(pianifMese + '-01'), 'MMMM yyyy', { locale: it })}?`)) return;
                    try {
                      await axios.delete(`${API}/config/obiettivi-mensili/${pianifMese}`, { headers: { Authorization: `Bearer ${token}` } });
                      toast.success('Pianificazione rimossa');
                      fetchObiettiviMensili();
                      fetchPianificazioneAnnuale();
                      refetchSoglie();
                      setPianifDialogOpen(false);
                    } catch { toast.error('Errore'); }
                  }}
                  data-testid="btn-elimina-pianif"
                >
                  🗑️ Rimuovi
                </Button>
              )}
              <Button variant="outline" onClick={() => setPianifDialogOpen(false)} className="flex-1">
                Annulla
              </Button>
              <Button
                disabled={savingPianif}
                onClick={async () => {
                  setSavingPianif(true);
                  try {
                    await axios.put(
                      `${API}/config/obiettivi-mensili/${pianifMese}`,
                      { obiettivo: pianifForm.obiettivo, soglie: pianifForm.soglie },
                      { headers: { Authorization: `Bearer ${token}` } }
                    );
                    toast.success(`Pianificazione salvata per ${format(new Date(pianifMese + '-01'), 'MMMM yyyy', { locale: it })}`);
                    fetchObiettiviMensili();
                    fetchPianificazioneAnnuale();
                    setMeseSelezionato(pianifMese);
                    refetchSoglie(undefined, pianifMese);
                    setPianifDialogOpen(false);
                  } catch { toast.error('Errore nel salvataggio'); }
                  finally { setSavingPianif(false); }
                }}
                className="flex-1 bg-gradient-to-r from-amber-500 to-orange-500 hover:from-amber-600 hover:to-orange-600"
                data-testid="btn-salva-pianif"
              >
                {savingPianif ? 'Salvataggio...' : '💾 Salva Pianificazione'}
              </Button>
            </div>
          </div>
        </DialogContent>
      </Dialog>

      {/* Dialog Modifica Soglie di Spesa */}
      <Dialog open={soglieDialogOpen} onOpenChange={setSoglieDialogOpen}>
        <DialogContent className="!max-w-md w-[95vw] max-h-[85vh] overflow-y-auto">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2">
              ⚙️ Soglie di Spesa Mensili
            </DialogTitle>
          </DialogHeader>
          <div className="space-y-3 pt-2">
            <p className="text-xs text-slate-500">
              Imposta la % max di incasso mensile che vuoi destinare a ciascuna categoria. Se superi la soglia (o ti avvicini all'85%), riceverai un alert sul Desk.
            </p>
            
            {/* Obiettivo Fatturato Annuo */}
            <div className="bg-gradient-to-r from-blue-50 to-indigo-50 border border-blue-200 rounded-xl p-3">
              <label className="text-xs font-semibold text-blue-800 uppercase tracking-wide">
                🎯 Obiettivo Fatturato Annuo
              </label>
              <p className="text-[10px] text-slate-500 mb-2">
                Se impostato, calcola le % sul target mensile (obiettivo/12) invece che sull'incasso reale. Es: 160.000€ → target 13.333€/mese
              </p>
              <div className="flex items-center gap-2">
                <span className="text-sm text-slate-500">€</span>
                <input
                  type="number"
                  min="0"
                  step="1000"
                  value={soglieForm.obiettivo_fatturato_annuo ?? 0}
                  onChange={(e) => setSoglieForm({ ...soglieForm, obiettivo_fatturato_annuo: parseFloat(e.target.value) || 0 })}
                  className="flex-1 px-3 py-2 border border-blue-300 rounded-md text-right font-bold text-blue-900"
                  placeholder="160000"
                  data-testid="soglia-obiettivo-annuo"
                />
                <span className="text-xs text-slate-500">/anno</span>
              </div>
              {(soglieForm.obiettivo_fatturato_annuo > 0) && (
                <p className="text-[11px] text-blue-700 mt-1.5 font-semibold">
                  Target mensile: €{(soglieForm.obiettivo_fatturato_annuo / 12).toFixed(0)}
                </p>
              )}
            </div>
            
            <div className="border-t pt-3 mt-2">
              <p className="text-xs font-semibold text-slate-600 mb-2 uppercase tracking-wide">Soglie % per categoria</p>
            </div>
            {[
              { k: 'ordine_tecnico', label: 'Ordine Tecnico', color: 'purple' },
              { k: 'rivendita', label: 'Rivendita', color: 'teal' },
              { k: 'monouso', label: 'Monouso', color: 'amber' },
              { k: 'utenze', label: 'Utenze (luce, gas, internet)', color: 'blue' },
              { k: 'abbonamenti', label: 'Abbonamenti (software, canoni)', color: 'indigo' },
              { k: 'totale_spese', label: 'Totale Spese (globale)', color: 'red' }
            ].map(s => (
              <div key={s.k} className="flex items-center gap-3">
                <label className={`flex-1 text-sm font-medium text-${s.color}-700`}>{s.label}</label>
                <div className="relative">
                  <input
                    type="number"
                    min="0"
                    max="100"
                    step="0.5"
                    value={soglieForm[s.k] ?? 0}
                    onChange={(e) => setSoglieForm({ ...soglieForm, [s.k]: parseFloat(e.target.value) || 0 })}
                    className="w-20 pr-6 pl-2 py-1.5 border border-slate-300 rounded-md text-right text-sm"
                    data-testid={`soglia-${s.k}`}
                  />
                  <span className="absolute right-2 top-1/2 -translate-y-1/2 text-xs text-slate-400">%</span>
                </div>
              </div>
            ))}
            <div className="flex gap-2 pt-3">
              <Button variant="outline" onClick={() => setSoglieDialogOpen(false)} className="flex-1">
                Annulla
              </Button>
              <Button
                disabled={savingSoglie}
                onClick={async () => {
                  setSavingSoglie(true);
                  try {
                    await axios.put(
                      `${API}/config/soglie-spesa`,
                      { soglie: soglieForm },
                      { headers: { Authorization: `Bearer ${token}` } }
                    );
                    toast.success("Soglie aggiornate");
                    setSoglieDialogOpen(false);
                    // Refetch nella modalità corrente
                    refetchSoglie();
                  } catch {
                    toast.error("Errore salvataggio");
                  } finally {
                    setSavingSoglie(false);
                  }
                }}
                className="flex-1 bg-blue-600 hover:bg-blue-700"
                data-testid="btn-salva-soglie"
              >
                {savingSoglie ? "Salvataggio..." : "Salva Soglie"}
              </Button>
            </div>
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
}
